import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import {
  FormBuilder,
  FormGroup,
  FormArray,
  Validators,
  FormControl
} from "@angular/forms";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { ActivatedRoute, Params } from "@angular/router";

import { environment } from "../../../../environments/environment";
import { CrudService } from "../../../crud/crud.service";
import { NotificationsService } from 'angular2-notifications';

import { Mensaje } from "../../../mensaje";

import jsPDF from 'jspdf'; import autoTable from 'jspdf-autotable'; import * as jQuery from 'jquery';
import * as moment from 'moment';

import { materialize } from 'rxjs/operators';

@Component({
  selector: "app-registro-escolaridad",
  templateUrl: "./lista.component.html"
})
export class RegistroEscolaridadComponent implements OnInit {
  dato = [];
  total_alumnos = 0;
  total_grupos = 0;
  total_carreras = 0;

  alumnos_repeticion = [];
  alumnos_alta = [];

  configuracion = JSON.parse(localStorage.getItem("configuracion"));
  API_PATH = environment.API_PATH;

  documentos = [];

  grupo_sel;
  grupo;
  periodo_sel;
  cargando = false;

  logo_sucursal = "";
  logo_empresa = "";

  activos = false;

  firma = {
    director1: '',
    director_sexo1: 'H',
    director2: '',
    director_sexo2: 'H',
    valida1: '',
    valida_sexo1: 'H',
    valida2: '',
    valida_sexo2: 'H',
    jefe1: '',
    jefe_sexo1: 'H',
    jefe2: '',
    jefe_sexo2: 'H',
    fecha1: '',
    fecha2: '',
    fecha3: '',
    cancelar1: false,
    cancelar2: false,
    cancelar3: false,
    fin_curso: false,
    situacion_a_na: true,
    situacion_a_se: true,
    situacion_p_na: true,
    situacion_p_se: true,
    calificaciones: true,
    color_calf_r: 'black',
    color_calf_t: 'black',
    diagonal: false,
    vacia: true
  };

  mensajeResponse: Mensaje = new Mensaje(true);
  //mostrar notificaciones
  public options = {
    position: ["middle", "center"],
    timeOut: 3000,
    lastOnBottom: true
  };

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private crudService: CrudService,
    private notificacion: NotificationsService
  ) { }




  ngOnInit() {

  //  this.obtenerdocumentos("REGISTRO_ESCOLARIDAD " + this.configuracion.nivel_educativo.nombre.toUpperCase());
    this.obtenerdocumentos("REGISTRO_ESCOLAR");

    document.getElementById("catalogos").click();
    if (localStorage.getItem("Nombre_Firma_" + this.configuracion.nivel_educativo.nombre))
      this.firma = JSON.parse(localStorage.getItem("Nombre_Firma_" + this.configuracion.nivel_educativo.nombre));
  }
  seleccionarPeriodo(event, id = '') {
    if (event) {
      if (event.hasOwnProperty("value")) {
        this.periodo_sel = event.value;
      } else {
        this.periodo_sel = event;
      }
      if (id != '')
        document.getElementById(id).click();
    }
    this.grupo = null;
    this.grupo_sel = null;
  }
  seleccionarGrupo(event, grupos) {
    if (event) {
      if (event.hasOwnProperty("value")) {
        this.grupo_sel = null;
      } else {
        this.grupo_sel = event;
      }
      grupos.forEach(element => {
        if (element.id == this.grupo_sel) {
          this.grupo = element;
        }
      });
    }
  }
  seleccionarActivos(event) {
    if (event) {
      if (event.hasOwnProperty("value")) {
        this.grupo = null;
      } else {
        this.grupo = event;
      }
    }

    this.grupo_sel = null;
    this.periodo_sel = null;
  }
  parametros = {
    pagina: 0,
    limite: 0
  };

  dataError = [];
  estado = 0;





  ////*******************************************************************************************************************************************************
  ////*******************************************************************************************************************************************************
  ////*******************************************************************************************************************************************************






  cargarDatos() {
    this.dato = [];
    this.dataError = [];
    try {

      if ((this.periodo_sel || this.grupo_sel) || this.activos) {

        let ruta = '';
        if (this.configuracion.nivel_educativo.nombre == 'Postgrados')
          ruta = "-posgrado";
        if (this.configuracion.nivel_educativo.nombre == 'Licenciaturas')
          ruta = "-licenciatura";
        if (this.configuracion.nivel_educativo.nombre == 'Profesionalización')
          ruta = "-profesionalizacion";
        if (this.configuracion.nivel_educativo.nombre == 'Bachillerato')
          ruta = "-bachillerato";
        
        if (this.configuracion.nivel_educativo.nombre == 'LICENCIATURA')
        {
          ruta = "-licenciatura";
        }else{
          ruta = "-posgrado";
        }
          

        this.cargando = true;
        this.crudService
          .lista(
            this.parametros,
            "registro-escolaridad" + ruta +
            "?periodos_escolares_id=" +
            this.periodo_sel +
            "&grupos_id=" +
            this.grupo_sel +
            "&activos=" +
            this.activos
          )
          .subscribe(
            resultado => {
              this.cargando = false;
              this.estado = 0;
              this.dataError = [];
              if (resultado.status == 200) {
                this.dato = resultado.data;
                this.total_alumnos = resultado.total_alumnos;
                this.total_grupos = resultado.total_grupos;
                this.total_carreras = resultado.total_carreras;

                this.alumnos_repeticion = resultado.alumnos_repeticion;
                this.alumnos_alta = resultado.alumnos_alta;
              } else {
                this.mensajeResponse.titulo = "Sin datos";
                this.mensajeResponse.texto =
                  "Los alumnos no tienen calificación";
                this.mensajeResponse.clase = "warning";
                this.mensaje(3);
              }
            },
            error => {
              this.cargando = false;
              this.dataError = error.error;
              this.estado = 1;
              //console.log(this.dataError);
            }
          );
      }
    } catch (e) {
      console.log(e);
    }
  }



  ////*******************************************************************************************************************************************************
  ////*******************************************************************************************************************************************************
  ////*******************************************************************************************************************************************************
  ////*******************************************************************************************************************************************************




  mensaje(cuentaAtras: number = 6, posicion: any[] = ["middle", "center"]): void {
    let objeto = {
      showProgressBar: true,
      pauseOnHover: true,
      clickToClose: true,
      maxLength: this.mensajeResponse.texto.length
    };

    this.options = {
      position: posicion,
      timeOut: cuentaAtras * 1000,
      lastOnBottom: true
    };

    if (this.mensajeResponse.clase == "alert")
      this.notificacion.alert(
        this.mensajeResponse.titulo,
        this.mensajeResponse.texto,
        objeto
      );

    if (this.mensajeResponse.clase == "success")
      this.notificacion.success(
        this.mensajeResponse.titulo,
        this.mensajeResponse.texto,
        objeto
      );

    if (this.mensajeResponse.clase == "info")
      this.notificacion.info(
        this.mensajeResponse.titulo,
        this.mensajeResponse.texto,
        objeto
      );

    if (
      this.mensajeResponse.clase == "warning" ||
      this.mensajeResponse.clase == "warn"
    )
      this.notificacion.warn(
        this.mensajeResponse.titulo,
        this.mensajeResponse.texto,
        objeto
      );

    if (
      this.mensajeResponse.clase == "error" ||
      this.mensajeResponse.clase == "danger"
    )
      this.notificacion.error(
        this.mensajeResponse.titulo,
        this.mensajeResponse.texto,
        objeto
      );
  }

  ////*******************************************************************************************************************************************************
  ////*******************************************************************************************************************************************************
  ////*******************************************************************************************************************************************************
  ////*******************************************************************************************************************************************************


  obtenerdocumentos(tipo) {
    this.cargando = true;
    this.crudService.lista(this.parametros, "documentos?tipo_documento=" + tipo).subscribe(
      resultado => {
        if (resultado.status == 200) {
          this.documentos[tipo] = resultado.data;
        } else {
          this.mensajeResponse.titulo = "Documentos";
          this.mensajeResponse.texto = "No configurado";
          this.mensajeResponse.clase = "warning";
          this.mensaje(3);
        }
        this.cargando = false;
      },
      error => {
        this.cargando = false;
        this.mensajeResponse.titulo = "Error";
        this.mensajeResponse.texto = "Documentos";
        this.mensajeResponse.clase = "danger";
        this.mensaje(3);
      }
    );
  }


   ///********************************************************************************************************************************************************
  ///********************************************************************************************************************************************************
  ///********************************************************************************************************************************************************

  obtenerdocumentosNUEVO(tipo_documento,tipo_rvoe,niveles_educativos_id) {

    console.log('OBTENIENDO DOCUMENTO ...');

    this.cargando = true;
    this.crudService.lista(this.parametros, "documentos?tipo_documento=" + tipo_documento+"&tipo_rvoe="+tipo_rvoe+"&niveles_educativos_id="+niveles_educativos_id).subscribe(
      resultado => {
        if (resultado.status == 200) {
        //  if (tipo == "BOLETAS PARCIALES " + this.configuracion.nivel_educativo.nombre.toUpperCase()) {
            for (let index = 0; index < resultado.data.FOOTER.length; index++) {
              const element = resultado.data.FOOTER[index];
              //console.log(element);
              //for (let j = 0; j < element.estructuras_contenidos.length; j++) {
              const x = element.estructuras_contenidos[1];
              //console.log(x.contenido);


          // DESCOMENTAR ESTO    this.data.controls.footer.patchValue(x.contenido)
              //}
            }
          //}
          this.documentos[tipo_documento] = resultado.data;
              console.log(' DOCUMENTO OBTENIDO...');

        } else {
          this.mensajeResponse.titulo = "Documentos";
          this.mensajeResponse.texto = "No configurado";
          this.mensajeResponse.clase = "warning";
          this.mensaje(3);
        }
        this.cargando = false;
      },
      error => {
        this.cargando = false;
        this.mensajeResponse.titulo = "Error";
        this.mensajeResponse.texto = "Documentos";
        this.mensajeResponse.clase = "danger";
        this.mensaje(3);
      }
    );
  }



 

  ///*******************************************************************************************************************************************************
  ///*******************************************************************************************************************************************************
  ///*******************************************************************************************************************************************************



  asignarLogos(logos) {
    if (logos) {
      this.logo_sucursal = logos.sucursal;
      this.logo_empresa = logos.empresa;
    }
  }

  imprimirRegistro() {
    if (this.configuracion.nivel_educativo.nombre == 'Postgrados')
      this.imprimirRegistroPosgrado();
    if (this.configuracion.nivel_educativo.nombre == 'Licenciaturas')
      this.imprimirRegistroLicenciatura();
    if (this.configuracion.nivel_educativo.nombre == 'Profesionalización')
      this.imprimirRegistroLicenciatura();
    if (this.configuracion.nivel_educativo.nombre == 'Bachillerato')
      this.imprimirRegistroProfesionalizacion();

    if (this.configuracion.nivel_educativo.nombre == 'LICENCIATURA')
    {
      this.imprimirRegistroLicenciatura();
    }else{
            this.imprimirRegistroPosgrado();
         }
      


  }



  pdf_registro;


  imprimirRegistroLicenciatura() {  

   // this.obtenerdocumentos('BOLETA',this.grupo.tipo_rvoe,this.configuracion.nivel_educativo.id);


    //let document_name = "REGISTRO ESCOLARIDAD " + this.configuracion.nivel_educativo.nombre.toUpperCase();
    let document_name = "REGISTRO_ESCOLAR";
    let header = this.documentos[document_name]["HEADER"];
    let footer = this.documentos[document_name]["FOOTER"];

    let personas_firman = this.firma;
    localStorage.setItem('Nombre_Firma_' + this.configuracion.nivel_educativo.nombre, JSON.stringify(personas_firman));

    this.cargando = true;
    let num_alumnos = 0;
    let nuevas_columnas = 0;
    setTimeout(() => {
      this.pdf_registro = new jsPDF('l', 'mm', [612, 1008]); // 216 X 356
      this.pdf_registro.setFont("helvetica", "", "bold");
      this.pdf_registro.setFontSize(10);
      let pagina = this.dato.length;
      let hojas = 0;
      this.dato.forEach((data, contador) => {
        hojas++;
        let conteo_lienas = 5;
        if (header) {
          header.forEach(element => {
            let columna = 5;
            let fila = 5;
            let col = 0;
            let fil = 0;
            let col_no = 0;
            let ancho = 0;
            let alto = 0;
            element.estructuras_contenidos.forEach(elem => {
              ancho = 216 * (elem.ancho_porcentaje / 100);
              alto = 279 * (elem.alto_porcentaje / 100);
              col_no = 0;
              if (elem.tipo == "FOTO") {
                this.pdf_registro.addImage(
                  elem.logo,
                  "PNG",
                  columna,
                  fila,
                  ancho,
                  alto,
                  "",
                  "FAST"
                );
              } else {
                try {
                  elem.contenido =
                    "<div style='line-height: 20px;'>" +
                    elem.contenido.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>') +
                    "</div>";

                  this.pdf_registro.fromHTML(elem.contenido, columna, conteo_lienas, {
                    width: ancho + columna
                  });
                } catch (e) {
                  console.log(e);
                }
              }
              columna += ancho + 1;
              col++;
            });
          });
        }

        this.pdf_registro.setFont("helvetica", "", "bold");
        this.pdf_registro.setFontSize(10);

        this.pdf_registro.setLineWidth(0.1);
        this.pdf_registro.setDrawColor(1, 1, 1);
        this.pdf_registro.setFillColor(255, 255, 255);

        ////////////////////// ESTADISTICA //////////////////////////////////////

        this.pdf_registro.rect(290, conteo_lienas, 56, 32, 'FD');

        this.pdf_registro.line(290, conteo_lienas + 4, 346, conteo_lienas + 4);
        this.pdf_registro.line(290, conteo_lienas + 21, 346, conteo_lienas + 21);
        this.pdf_registro.line(290, conteo_lienas + 26.5, 346, conteo_lienas + 26.5);

        this.pdf_registro.line(319, conteo_lienas + 4, 319, conteo_lienas + 32);
        this.pdf_registro.line(328, conteo_lienas + 4, 328, conteo_lienas + 32);
        this.pdf_registro.line(337, conteo_lienas + 4, 337, conteo_lienas + 32);

        this.pdf_registro.setFontSize(8);
        this.pdf_registro.text("DATOS ESTADISTICOS", 322, conteo_lienas + 3, { align: 'center' });
        this.pdf_registro.text("CONCEPTO", 292, conteo_lienas + 13, { align: 'left' });
        this.pdf_registro.text("INICIO DE CURSO", 292, conteo_lienas + 24.5, { align: 'left' });
        this.pdf_registro.text("FIN DE CURSO", 292, conteo_lienas + 30, { align: 'left' });

        this.pdf_registro.text('HOMBRES', 325, conteo_lienas + 20, { align: 'left', angle: 90, });
        this.pdf_registro.text('MUJERES', 334, conteo_lienas + 20, { align: 'left', angle: 90, });
        this.pdf_registro.text('TOTAL', 342, conteo_lienas + 20, { align: 'left', angle: 90, });

        this.pdf_registro.text((data.total_hombres_inicio) + '', 323, conteo_lienas + 24.5, { align: 'left' });
        this.pdf_registro.text((data.total_mujeres_inicio) + '', 331, conteo_lienas + 24.5, { align: 'left' });
        this.pdf_registro.text((data.total_hombres_inicio + data.total_mujeres_inicio) + '', 340, conteo_lienas + 24.5, { align: 'left' });

        if (this.firma.fin_curso) {
          this.pdf_registro.text((data.total_hombres) + '', 323, conteo_lienas + 30, { align: 'left' });
          this.pdf_registro.text((data.total_mujeres) + '', 331, conteo_lienas + 30, { align: 'left' });
          this.pdf_registro.text((data.total_hombres + data.total_mujeres) + '', 340, conteo_lienas + 30, { align: 'left' });
        }

        this.pdf_registro.setFontSize(10);
        conteo_lienas += 38;

        //////////////////////// ESCUELA ////////////////////////////////////

        this.pdf_registro.text("ESCUELA:", 10, conteo_lienas, { align: "left" });
        this.pdf_registro.line(34, conteo_lienas + 1, 165, conteo_lienas + 1);

        this.pdf_registro.text("LOCALIDAD:", 10, conteo_lienas + 5, { align: "left" });
        this.pdf_registro.line(34, conteo_lienas + 6, 165, conteo_lienas + 6);

        this.pdf_registro.text("CARRERA:", 10, conteo_lienas + 10, { align: "left" });
        this.pdf_registro.line(34, conteo_lienas + 11, 165, conteo_lienas + 11);

        this.pdf_registro.text("MODALIDAD:", 10, conteo_lienas + 15, { align: "left" });
        this.pdf_registro.line(34, conteo_lienas + 16, 165, conteo_lienas + 16);

        this.pdf_registro.setFont("helvetica", "", "normal");

        this.pdf_registro.text(this.configuracion.empresa.nombre + " " + this.configuracion.empresa.subnombre, 36, conteo_lienas, { align: "left" });
        this.pdf_registro.text(this.configuracion.sucursal.direccion.split(",")[1].toUpperCase().trim(), 36, conteo_lienas + 5, { align: "left" });
        this.pdf_registro.text(data.carreras_planes.carreras.nombre, 36, conteo_lienas + 10, { align: "left" });
        this.pdf_registro.text(data.periodos_escolares.modalidades.nombre_imprimir, 36, conteo_lienas + 15, { align: "left" });

        this.pdf_registro.setFont("helvetica", "", "bold");

        //////////////////////// CLAVE ////////////////////////////////////

        this.pdf_registro.text("CLAVE:", 170, conteo_lienas, { align: "left" });
        this.pdf_registro.line(190, conteo_lienas + 1, 240, conteo_lienas + 1);

        this.pdf_registro.text("TURNO:", 170, conteo_lienas + 5, { align: "left" });
        this.pdf_registro.line(190, conteo_lienas + 6, 240, conteo_lienas + 6);

        this.pdf_registro.text("RVOE:", 170, conteo_lienas + 10, { align: "left" });
        this.pdf_registro.line(190, conteo_lienas + 11, 240, conteo_lienas + 11);
        if (data.carreras_planes.vigente_desde) {
          this.pdf_registro.text("VIGENTE:", 170, conteo_lienas + 15, { align: "left" });
          this.pdf_registro.line(190, conteo_lienas + 16, 290, conteo_lienas + 16);
        }

        this.pdf_registro.setFont("helvetica", "", "normal");
        this.pdf_registro.text(this.configuracion.sucursal.clave, 192, conteo_lienas, { align: "left" });
        this.pdf_registro.text(data.turnos.nombre, 192, conteo_lienas + 5, { align: "left" });
        this.pdf_registro.text(data.carreras_planes.rvoe, 192, conteo_lienas + 10, { align: "left" });
        this.pdf_registro.text(data.carreras_planes.vigente_desde ? data.carreras_planes.vigente_desde : "", 192, conteo_lienas + 15, { align: "left" });
        this.pdf_registro.setFont("helvetica", "", "bold");

        /////////////////////// CICLO ESCOLAR /////////////////////////////////////
        let anio_actual = data.periodos_escolares.fecha_inicio.substr(0, 4);
        let anio_anterior = anio_actual - 1;
        this.pdf_registro.text("CICLO ESCOLAR:", 245, conteo_lienas, { align: "left" });
        this.pdf_registro.line(282, conteo_lienas + 1, 346, conteo_lienas + 1);

        this.pdf_registro.text(data.periodos_escolares.tipos_periodos.nombre + ":", 245, conteo_lienas + 5, { align: "left" });
        this.pdf_registro.line(282, conteo_lienas + 6, 310, conteo_lienas + 6);

        this.pdf_registro.text("GRUPO:", 312, conteo_lienas + 5, { align: "left" });
        this.pdf_registro.line(325, conteo_lienas + 6, 346, conteo_lienas + 6);

        this.pdf_registro.text("PERIODO ESCOLAR:", 245, conteo_lienas + 10, { align: "left" });
        this.pdf_registro.line(282, conteo_lienas + 11, 346, conteo_lienas + 11);

        this.pdf_registro.setFont("helvetica", "", "normal");
        this.pdf_registro.text(data.periodos_escolares.ciclos_escolares ? data.periodos_escolares.ciclos_escolares.nombre : '', 284, conteo_lienas, { align: "left" });
        this.pdf_registro.text(data.nivel + "", 284, conteo_lienas + 5, { align: "left" });
        this.pdf_registro.text(data.identificador, 327, conteo_lienas + 5, { align: "left" });
        this.pdf_registro.text(data.periodos_escolares.nombre, 284, conteo_lienas + 10, { align: "left" });
        this.pdf_registro.setFont("helvetica", "", "bold");

        let total_alumnos = data.alumnos.length;

        this.pdf_registro.text("HOJA:", 295, conteo_lienas + 15, { align: "left" });
        this.pdf_registro.line(308, conteo_lienas + 16, 318, conteo_lienas + 16);
        this.pdf_registro.text(hojas + "", 312, conteo_lienas + 15, { align: "left" });

        this.pdf_registro.text("DE:", 322, conteo_lienas + 15, { align: "left" });
        this.pdf_registro.line(332, conteo_lienas + 16, 346, conteo_lienas + 16);
        this.pdf_registro.text(pagina + "", 337, conteo_lienas + 15, { align: "left" });

        conteo_lienas += 20;

        let materia_nivel = [];
        data.carreras_planes.materias.forEach(materia => {
          if (materia.nivel == data.nivel) {
            materia_nivel.push(materia);
          }
        });

        nuevas_columnas = Math.round(materia_nivel.length / 2);

        let opcion_calificacion = [];
        data.carreras_planes.opciones_calificacion.forEach(opcion => {
          if (opcion.modalidades_id == data.periodos_escolares.modalidades_id) {
            opcion_calificacion.push(opcion);
          }
        });

        let tam_mat = 0; let tamanio_materia = [];
        materia_nivel.forEach((materia, key) => {
          var splitTitle = this.pdf_registro.splitTextToSize(materia.nombre, 33);
          let suma_texto = 0, tamano_texto = 1;
          splitTitle.forEach(texto => {
            if (texto.length + suma_texto >= 33) {
              tamano_texto++;
              suma_texto = 0;
            } else {
              suma_texto += 33;
            }
          });
          if (suma_texto > 0) {
            tamano_texto++;
          }
          if (tamano_texto < splitTitle.length) {
            tamano_texto = splitTitle.length;
          }
          if (materia_nivel.length == 3) {
            tamanio_materia[key] = 15;
          } else if (materia_nivel.length == 2) {
            tamanio_materia[key] = 20;
          } else if (materia_nivel.length == 1) {
            tamanio_materia[key] = 40;
          } else {
            tamanio_materia[key] = splitTitle.length == 1 ? 8 : (tamano_texto * 3.2) + 2;
          }

          tam_mat += tamanio_materia[key];
        });

        let conteo_columnas = 0;
        // let total_col_cal = ((opcion_calificacion.length * 3) * 8);
        let total_col_cal = ((nuevas_columnas * 3) * 8);
        let num_columns = 330;

        let p_al = 330 - total_col_cal;
        p_al = p_al - tam_mat - 8;

        this.cabecera_alumnos_licenciatura(data, conteo_lienas, p_al, opcion_calificacion, materia_nivel, total_col_cal, 145, 207.5, tam_mat, tamanio_materia, nuevas_columnas);

        this.pdf_registro.setFontSize(9); /* modificar el tamaño de fuente para ajustar nombre de 10 a 90*/
        conteo_lienas += 40;

        let lineas_alumnos = conteo_lienas;
        this.pdf_registro.setLineWidth(0.5);
        for (let i = 1; i < 26; i++) {
          this.pdf_registro.line(10, lineas_alumnos, 346, lineas_alumnos);
          this.pdf_registro.setLineWidth(0.1);
          this.pdf_registro.text((i + num_alumnos) + "", 13.5, lineas_alumnos + 3, { align: "center" });
          lineas_alumnos += 4.2;
        }
        num_alumnos += 25;

        lineas_alumnos = conteo_lienas + 3;

        //////////////// INFORMACION ALUMNOS /////////////////////
        let letras = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L"];
        this.pdf_registro.setFont("helvetica", "", "normal");
        let menos_linea = 0;
        data.alumnos.forEach((alumno, key) => {
          this.pdf_registro.setTextColor("black");

          if (alumno.id == '99ff2e5aa51bc2341f2bab473bc8349c') {
            console.log(alumno.nombre + ' ' + alumno.apellido_paterno);
            alumno.calificaciones["situacion_escolar_antes"] = "P"
          }
          if (this.firma.situacion_a_na) {
            this.pdf_registro.text(alumno.calificaciones["asignaturas_no_acreditadas_antes"] + "", 21, lineas_alumnos, { align: "left" });
          }
          if (this.firma.situacion_a_se) {
            this.pdf_registro.text(alumno.calificaciones["situacion_escolar_antes"], 29, lineas_alumnos, { align: "left" });
          }
          this.pdf_registro.text(alumno.matricula.substr(4, alumno.matricula.length), 43, lineas_alumnos, { align: "center" });
          let left_mas = 0;
          if (p_al < 155) {
            left_mas = (p_al / 3) - 21.5;
            if (left_mas < 0) {
              left_mas = 4;
            }
          } else {
            left_mas = (p_al / 3) - 23;
          }
          this.pdf_registro.text(alumno.apellido_paterno, 52, lineas_alumnos, { align: "left" });
          this.pdf_registro.text(alumno.apellido_materno, 52 + left_mas, lineas_alumnos, { align: "left" });
          this.pdf_registro.text(alumno.nombre, 52 + (left_mas * 2), lineas_alumnos, { align: "left" });

          this.pdf_registro.text(alumno.sexo, p_al + 5, lineas_alumnos, { align: "center" });

          let col_mat = p_al + 8;
          // calificaciones
          materia_nivel.forEach((materia, key) => {
            var splitTitle = this.pdf_registro.splitTextToSize(materia.nombre, 33);
            let tamanio = tamanio_materia[key];
            col_mat += tamanio;


            if (alumno.calificaciones[materia.id] == undefined) {
              console.log(alumno.nombre + ' ' + alumno.apellido_paterno);
            }
            if (alumno.calificaciones[materia.id][0].promedio < alumno.calificaciones[materia.id][0].valor_minimo_aprobatorio)
              this.pdf_registro.setTextColor(this.firma.color_calf_r); // red
            else
              this.pdf_registro.setTextColor("black");

            this.pdf_registro.setFontSize(10);/* SE PUSO ESTA FUENTE PARA NO MODIFICAR LAS CALF Y SITUACION ESCOLAR*/

            if (this.firma.calificaciones) {
              let calf = alumno.calificaciones[materia.id][0].promedio;

              if (alumno.calificaciones["situacion_escolar"] == 'BD') {
                calf = '';
              }

              if (this.firma.diagonal) {

                // if (alumno.calificaciones["situacion_escolar"] == 'BT') {
                //   this.pdf_registro.line(col_mat - tamanio, lineas_alumnos - 3.2, col_mat, lineas_alumnos + 1);
                //   //this.pdf_registro.setTextColor(255,255,255);
                //   //this.pdf_registro.text( ' ',col_mat - tamanio / 2, lineas_alumnos, {align:"center"});
                // }
                if (calf != '==' && calf != '' && alumno.calificaciones["situacion_escolar"] != 'BT' && alumno.calificaciones["situacion_escolar"] != 'BD') {
                  this.pdf_registro.text(calf + '', col_mat - tamanio / 2, lineas_alumnos, { align: "center" });
                } else {
                  this.pdf_registro.line(col_mat - tamanio, lineas_alumnos - 3.2, col_mat, lineas_alumnos + 1);
                }

              } else {
                this.pdf_registro.text(calf + '', col_mat - tamanio / 2, lineas_alumnos, { align: "center" });
              }

            }
          });

          // col_mat = p_al + 8;
          // materia_nivel.forEach(materia => {
          //   var splitTitle = this.pdf_registro.splitTextToSize(materia.nombre, 33);
          //   col_mat += splitTitle.length == 1 ? 7.13 : splitTitle.length * 4.13;
          // });

          this.pdf_registro.setTextColor("black");
          let maximo_reprobado = 0;
          let col_mat_text = col_mat - 3;
          //* evalucion de valores en el array reprobados 
          let reprobadas = [];
          let reprobadas_dos = [];
          let reprobadas_general = [];
          ///// var b = '';
          for (let index = 0; index < letras.length; index++) {
            var letra = letras[index];
            if (alumno.reprobadas.hasOwnProperty(letra)) { //? <-- se compara la key de reprobados con el arreglo de letras

              // // if (alumno.reprobadas[letra].aprobado == null) {
              // // }
              //?<-- se evalua si esta o no marcada la casilla para ver las calificaciones
              if (this.firma.calificaciones) {
                //? se evalua si la situacion escolar es diferente de las bajas que existen en el sistema
                if (alumno.calificaciones["situacion_escolar"] != 'BR' && alumno.calificaciones["situacion_escolar"] != 'BT' && alumno.calificaciones["situacion_escolar"] != 'BD') {
                  //? se evalua si la variable es diferente de null
                  if (alumno.reprobadas[letra].aprobado != null) {

                    //? si es asi se inserta el obejto al array reprobadas
                    reprobadas.push({
                      id: letra.toString(),
                      promedio: alumno.reprobadas[letra].promedio,
                      opc: alumno.reprobadas[letra].opciones_calificacion.nombre
                    });
                  } else {

                    //? caso contrario se añade al array reprobadas dos
                    reprobadas_dos.push({
                      id: '-',
                      promedio: '-',
                      opc: '-'
                    });
                  }
                }
              }
              //? por ultimo se concatena ambos arrays

              reprobadas_general = reprobadas.concat(reprobadas_dos)

              //!NOTA: se llevo acabo este proceso debido a los requisitos presentados 
              //!en caso de no que la primera objeto viniera en null se recorriera el siguiente
            }
          }

          //* impresion en el PDF del array analizado anteriormente
          //? se recorre el array concatenado
          for (let j = 0; j < reprobadas_general.length; j++) {
            const calf_reprobadas = reprobadas_general[j];

            //? se condiciona al numero de columnas admitidas
            if (maximo_reprobado < nuevas_columnas) {

              //? impresion de las variables del objeto
              //? 11-01-2024 -> se ajusto para que la eiqueta de calificacion regularizadas sea visible
              this.pdf_registro.text(calf_reprobadas.id, col_mat_text + 6 + (j * 24), lineas_alumnos, { align: 'center' });
              this.pdf_registro.text(calf_reprobadas.promedio.toString(), col_mat_text + 14 + (j * 24), lineas_alumnos, { align: 'center' });
              this.pdf_registro.setFontSize(9);
              this.pdf_registro.text(calf_reprobadas.opc, col_mat_text + 22.5 + (j * 24), lineas_alumnos, { align: 'center', maxWidth: 33 });
              maximo_reprobado++
            }
          }

          // //console.log(reprobadas_general);



          //!esto es lo que se evaluaba antes
          // letras.forEach(letra => {
          //   if (alumno.reprobadas.hasOwnProperty(letra)) {
          //     if (alumno.calificaciones["situacion_escolar"] != 'BR' && alumno.calificaciones["situacion_escolar"] != 'BT' && alumno.calificaciones["situacion_escolar"] != 'BD') {
          //       if (alumno.reprobadas[letra].valor_minimo_aprobatorio != null) {
          //         this.pdf_registro.text(letra, col_mat_text + 7, lineas_alumnos, { align: "center" });
          //         this.pdf_registro.text(alumno.reprobadas[letra].promedio + '', col_mat_text + 15, lineas_alumnos, { align: "center" });
          //         this.pdf_r20egistro.text(alumno.reprobadas[letra].opciones_calificacion.nombre, col_mat_text + 23, lineas_alumnos, { align: "center" });

          //         maximo_reprobado++;

          //         col_mat_text += 24;
          //       }
          //     }              
          //   }
          // });

          if (alumno.calificaciones["situacion_escolar"] == 'BR' || alumno.calificaciones["situacion_escolar"] == 'BD' || alumno.calificaciones["situacion_escolar"] == 'BT') {
            this.pdf_registro.setTextColor(this.firma.color_calf_t); //red
            let col_mat_blanco = 330 - total_col_cal;
            let left_op = total_col_cal;
            col_mat = col_mat_blanco;
            if (this.firma.situacion_p_se) {
              this.pdf_registro.setLineWidth(0.8);
              this.pdf_registro.setDrawColor(255, 255, 255);
              // for (let key = 0; key < (opcion_calificacion.length * 3) - 1; key++) {
              for (let key = 0; key < (nuevas_columnas * 3) - 1; key++) {
                col_mat_blanco += 8;
                this.pdf_registro.line(col_mat_blanco, lineas_alumnos - 2.9 + menos_linea, col_mat_blanco, lineas_alumnos + 1.1 + menos_linea);
              }
              this.pdf_registro.setDrawColor(1, 1, 1);
              this.pdf_registro.setLineWidth(0.1);

              this.pdf_registro.text(alumno.calificaciones["situacion_escolar_descripcion"], col_mat + (left_op / 2), lineas_alumnos, { align: "center" });
            }
          }

          // if(this.firma.vacia){
          //   let col_mat_blanco = 330 - total_col_cal;
          //   let left_op = total_col_cal;
          //   if (alumno.calificaciones["asignaturas_no_acreditadas"] == '==') {
          //     for (let key = 0; key < (opcion_calificacion.length * 3) - 1; key++) {
          //       col_mat_blanco += 8;
          //       this.pdf_registro.line(col_mat_blanco, lineas_alumnos - 2.9 + menos_linea, col_mat_blanco, lineas_alumnos + 1.1 + menos_linea);
          //       console.log(col_mat_blanco);

          //     }

          //     this.pdf_registro.text(alumno.calificaciones["situacion_escolar_descripcion"], col_mat + (left_op / 2), lineas_alumnos, { align: "center" });
          //   }

          //  }
          this.pdf_registro.setTextColor("black");
          if (this.firma.situacion_p_na) {
            let anc = alumno.calificaciones["asignaturas_no_acreditadas"];
            if (this.firma.diagonal) {
              if (anc != '==' && anc != '') {
                //?se agrego la condicion para los casos de baja temporal y por desercion para que no salga la cant de asignaturas no acreditadas
                if (alumno.calificaciones["situacion_escolar"] != 'BD' && alumno.calificaciones["situacion_escolar"] != 'BT') {
                  this.pdf_registro.text(anc + "", 333, lineas_alumnos, { align: "left" });
                } else {
                  this.pdf_registro.line(330, lineas_alumnos - 3.2, 338, lineas_alumnos + 1);
                }

              } else {
                this.pdf_registro.line(330, lineas_alumnos - 3.2, 338, lineas_alumnos + 1);
              }
            } else {
              this.pdf_registro.text(anc + "", 333, lineas_alumnos, { align: "left" });
            }
          }
          if (this.firma.situacion_p_se) {
            this.pdf_registro.text(alumno.calificaciones["situacion_escolar"], 340, lineas_alumnos, { align: "left" });
          }
          lineas_alumnos += 4.23;
          menos_linea -= 0.022;
        });
        // linea cancelacion diagonal
        this.pdf_registro.setLineWidth(0.3);
        if (data.alumnos.length < 25) {
          this.pdf_registro.line(18, lineas_alumnos - 3, 346, 207.5);
        }

        this.pdf_registro.addPage();
        conteo_lienas = 10;

        //////////////// INFORMACION ALUMNOS /////////////////////
        this.cabecera_alumnos_licenciatura(data, conteo_lienas, p_al, opcion_calificacion, materia_nivel, total_col_cal, 41, 50.5, tam_mat, tamanio_materia, nuevas_columnas);
        this.pdf_registro.setFontSize(10);
        conteo_lienas += 45;

        this.pdf_registro.text("ALUMNOS QUE REPITEN CURSO", 185, conteo_lienas, { align: "center" });

        conteo_lienas += 3;
        let alumnos_repiten = 6;
        this.alumnos_lineas_licenciatura(alumnos_repiten, conteo_lienas, p_al, opcion_calificacion, materia_nivel, total_col_cal, tam_mat, tamanio_materia, nuevas_columnas);
        //////////////// ALUMNOS QUE REPITEN
        lineas_alumnos = conteo_lienas + 3; let conteo_repiten = 0;
        if (this.alumnos_repeticion.hasOwnProperty(data.id)) {
          
          this.pdf_registro.setFont("helvetica", "", "normal");
          menos_linea = 0;
          this.alumnos_repeticion[data.id].forEach((alumno, key) => {
            conteo_repiten++;
            if (alumno.calificaciones["asignaturas_no_acreditadas"] == 0) {
              alumno.calificaciones["asignaturas_no_acreditadas"] = "=="
            }
            this.pdf_registro.setTextColor("black");
            this.pdf_registro.text( conteo_repiten + "", 13.5, lineas_alumnos, { align: "center" });
            if (this.firma.situacion_a_na) {
              this.pdf_registro.text(alumno.calificaciones["asignaturas_no_acreditadas_antes"] + "", 21, lineas_alumnos, { align: "left" });
            }
            if (this.firma.situacion_a_se) {
              this.pdf_registro.text(alumno.calificaciones["situacion_escolar_antes"], 29, lineas_alumnos, { align: "left" });
            }
            this.pdf_registro.text(alumno.matricula.substr(4, alumno.matricula.length), 43, lineas_alumnos, { align: "center" });
            let left_mas = 0;
            if (p_al < 155) {
              left_mas = (p_al / 3) - 21.5;
              if (left_mas < 0) {
                left_mas = 4;
              }
            } else {
              left_mas = (p_al / 3) - 23;
            }
            this.pdf_registro.text(alumno.apellido_paterno, 52, lineas_alumnos, { align: "left" });
            this.pdf_registro.text(alumno.apellido_materno, 52 + left_mas, lineas_alumnos, { align: "left" });
            this.pdf_registro.text(alumno.nombre, 52 + (left_mas * 2), lineas_alumnos, { align: "left" });

            this.pdf_registro.text(alumno.sexo, p_al + 5, lineas_alumnos, { align: "center" });

            let col_mat = p_al + 8;
            // calificaciones
            materia_nivel.forEach((materia, key) => {
              let tamanio = tamanio_materia[key];
              col_mat += tamanio;
              if (alumno.calificaciones.hasOwnProperty(materia.id)) {
                if (alumno.calificaciones[materia.id][0].promedio < alumno.calificaciones[materia.id][0].valor_minimo_aprobatorio)
                  this.pdf_registro.setTextColor(this.firma.color_calf_r); // red
                else
                  this.pdf_registro.setTextColor("black");

                if (this.firma.calificaciones) {
                  this.pdf_registro.text(alumno.calificaciones[materia.id][0].promedio + '', col_mat - tamanio / 2, lineas_alumnos, { align: "center" });
                }
              }
            });

            col_mat = p_al + 8;
            materia_nivel.forEach(materia => {
              var splitTitle = this.pdf_registro.splitTextToSize(materia.nombre, 33);
              col_mat += splitTitle.length == 1 ? 7.13 : splitTitle.length * 4.13;
            });

            this.pdf_registro.setTextColor("black");
            let maximo_reprobado = 0;
            let col_mat_text = col_mat - 3;
            //* evalucion de valores en el array reprobados 
            let reprobadas = [];
            let reprobadas_dos = [];
            let reprobadas_general = [];
            ///// var b = '';
            for (let index = 0; index < letras.length; index++) {
              var letra = letras[index];
              if (alumno.reprobadas.hasOwnProperty(letra)) { //? <-- se compara la key de reprobados con el arreglo de letras

                // // if (alumno.reprobadas[letra].aprobado == null) {
                // // }
                //?<-- se evalua si esta o no marcada la casilla para ver las calificaciones
                if (this.firma.calificaciones) {
                  //? se evalua si la situacion escolar es diferente de las bajas que existen en el sistema
                  if (alumno.calificaciones["situacion_escolar"] != 'BR' && alumno.calificaciones["situacion_escolar"] != 'BT' && alumno.calificaciones["situacion_escolar"] != 'BD') {
                    //? se evalua si la variable es diferente de null
                    if (alumno.reprobadas[letra].aprobado != null) {

                      //? si es asi se inserta el obejto al array reprobadas
                      reprobadas.push({
                        id: letra.toString(),
                        promedio: alumno.reprobadas[letra].promedio,
                        opc: alumno.reprobadas[letra].opciones_calificacion.nombre
                      });
                    } else {

                      //? caso contrario se añade al array reprobadas dos
                      reprobadas_dos.push({
                        id: '-',
                        promedio: '-',
                        opc: '-'
                      });
                    }
                  }
                }
                //? por ultimo se concatena ambos arrays

                reprobadas_general = reprobadas.concat(reprobadas_dos)

                //!NOTA: se llevo acabo este proceso debido a los requisitos presentados 
                //!en caso de no que la primera objeto viniera en null se recorriera el siguiente
              }
            }

            //* impresion en el PDF del array analizado anteriormente
            //? se recorre el array concatenado
            for (let j = 0; j < reprobadas_general.length; j++) {
              const calf_reprobadas = reprobadas_general[j];

              //? se condiciona al numero de columnas admitidas
              if (maximo_reprobado < nuevas_columnas) {

                //? impresion de las variables del objeto
                //? 11-01-2024 -> se ajusto para que la eiqueta de calificacion regularizadas sea visible
                this.pdf_registro.text(calf_reprobadas.id, col_mat_text + 6 + (j * 24), lineas_alumnos, { align: 'center' });
                this.pdf_registro.text(calf_reprobadas.promedio.toString(), col_mat_text + 14 + (j * 24), lineas_alumnos, { align: 'center' });
                this.pdf_registro.setFontSize(9);
                this.pdf_registro.text(calf_reprobadas.opc, col_mat_text + 22.5 + (j * 24), lineas_alumnos, { align: 'center', maxWidth: 33 });
                maximo_reprobado++
              }
            }

            // let maximo_reprobado = 0;
            // let col_mat_text = col_mat - 3;
            // letras.forEach(letra => {
            //   if (alumno.reprobadas.hasOwnProperty(letra)) {
            //     if (maximo_reprobado < 3) {
            //       if (alumno.reprobadas[letra].valor_minimo_aprobatorio != null) {
            //         this.pdf_registro.text(letra, col_mat_text + 7, lineas_alumnos, { align: "center" });
            //         this.pdf_registro.text(alumno.reprobadas[letra].promedio + '', col_mat_text + 15, lineas_alumnos, { align: "center" });
            //         this.pdf_registro.text(alumno.reprobadas[letra].opciones_calificacion.nombre, col_mat_text + 23, lineas_alumnos, { align: "center" });

            //         maximo_reprobado++;

            //         col_mat_text += 24;
            //       }
            //     }
            //   }
            // });

            if (alumno.calificaciones["situacion_escolar"] == 'BR' || alumno.calificaciones["situacion_escolar"] == 'BD' || alumno.calificaciones["situacion_escolar"] == 'BT') {
              this.pdf_registro.setTextColor(this.firma.color_calf_t); //red
              let col_mat_blanco = 330 - total_col_cal;
              let left_op = total_col_cal;
              col_mat = col_mat_blanco;
              if (this.firma.situacion_p_se) {
                this.pdf_registro.setLineWidth(0.8);
                this.pdf_registro.setDrawColor(255, 255, 255);
                // for (let key = 0; key < (opcion_calificacion.length * 3) - 1; key++) {
                for (let key = 0; key < (nuevas_columnas * 3) - 1; key++) {
                  col_mat_blanco += 8;
                  this.pdf_registro.line(col_mat_blanco, lineas_alumnos - 2.9 + menos_linea, col_mat_blanco, lineas_alumnos + 1.1 + menos_linea);
                }
                this.pdf_registro.setDrawColor(1, 1, 1);
                this.pdf_registro.setLineWidth(0.1);


                this.pdf_registro.text(alumno.calificaciones["situacion_escolar_descripcion"], col_mat + (left_op / 2), lineas_alumnos, { align: "center" });
              }
            }
            this.pdf_registro.setTextColor("black");
            //let prueba
            if (this.firma.situacion_p_na) {
              let anc = alumno.calificaciones["asignaturas_no_acreditadas"];
              if (this.firma.diagonal) {
                if (anc != '==' && anc != '') {
                  //?se agrego la condicion para los casos de baja temporal y por desercion para que no salga la cant de asignaturas no acreditadas
                  if (alumno.calificaciones["situacion_escolar"] != 'BD' && alumno.calificaciones["situacion_escolar"] != 'BT') {
                    this.pdf_registro.text(anc + "", 333, lineas_alumnos, { align: "left" });
                  } else {
                    this.pdf_registro.line(330, lineas_alumnos - 3.2, 338, lineas_alumnos + 1);
                  }

                } else {
                  this.pdf_registro.line(330, lineas_alumnos - 3.2, 338, lineas_alumnos + 1);
                }
              } else {
                this.pdf_registro.text(anc + "", 333, lineas_alumnos, { align: "left" });
              }
            }
            // if (this.firma.situacion_p_na) {
            //   this.pdf_registro.text(alumno.calificaciones["asignaturas_no_acreditadas"] + "", 333, lineas_alumnos, { align: "left" });
            // }
            if (this.firma.situacion_p_se) {
              this.pdf_registro.text(alumno.calificaciones["situacion_escolar"], 340, lineas_alumnos, { align: "left" });
            }
            lineas_alumnos += 4.23;
            menos_linea -= 0.022;
          });
        }
        /////////////// FIN REPITEN

        //////////////// INFORMACION ALUMNOS /////////////////////
        conteo_lienas += (alumnos_repiten * 4) + 5;

        this.pdf_registro.text("ALUMNOS DADOS DE ALTA", 185, conteo_lienas, { align: "center" });

        conteo_lienas += 3;
        let alumnos_nuevos = 6;

        this.alumnos_lineas_licenciatura(alumnos_nuevos, conteo_lienas, p_al, opcion_calificacion, materia_nivel, total_col_cal, tam_mat, tamanio_materia, nuevas_columnas);

        //////////////// ALUMNOS DADOS DE ALTA
        lineas_alumnos = conteo_lienas + 3.5; let conteo_alta = 0;
        if (this.alumnos_alta.hasOwnProperty(data.id)) {
         
          this.pdf_registro.setFont("helvetica", "", "normal");
          menos_linea = 0;
          this.alumnos_alta[data.id].forEach((alumno, key) => {
            conteo_alta++;
            this.pdf_registro.setTextColor("black");
            this.pdf_registro.text(conteo_alta + "", 13.5, lineas_alumnos, { align: "center" });
            if (this.firma.situacion_a_na) {
              this.pdf_registro.text(alumno.calificaciones["asignaturas_no_acreditadas_antes"] + "", 21, lineas_alumnos, { align: "left" });
            }
            if (this.firma.situacion_a_se) {
              this.pdf_registro.text(alumno.calificaciones["situacion_escolar_antes"], 29, lineas_alumnos, { align: "left" });
            }
            this.pdf_registro.text(alumno.matricula.substr(4, alumno.matricula.length), 43, lineas_alumnos, { align: "center" });
            let left_mas = 0;
            if (p_al < 155) {
              left_mas = (p_al / 3) - 21.5;
              if (left_mas < 0) {
                left_mas = 4;
              }
            } else {
              left_mas = (p_al / 3) - 23;
            }
            this.pdf_registro.text(alumno.apellido_paterno, 52, lineas_alumnos, { align: "left" });
            this.pdf_registro.text(alumno.apellido_materno, 52 + left_mas, lineas_alumnos, { align: "left" });
            this.pdf_registro.text(alumno.nombre, 52 + (left_mas * 2), lineas_alumnos, { align: "left" });

            this.pdf_registro.text(alumno.sexo, p_al + 5, lineas_alumnos, { align: "center" });

            let col_mat = p_al + 8;
            // calificaciones
            materia_nivel.forEach((materia, key) => {
              let tamanio = tamanio_materia[key];
              col_mat += tamanio;
              if (alumno.calificaciones.hasOwnProperty(materia.id)) {
                if (alumno.calificaciones[materia.id][0].promedio < alumno.calificaciones[materia.id][0].valor_minimo_aprobatorio)
                  this.pdf_registro.setTextColor(this.firma.color_calf_r); // red
                else
                  this.pdf_registro.setTextColor("black");
                this.pdf_registro.setFontSize(10);/* SE PUSO ESTA FUENTE PARA NO MODIFICAR LAS CALF Y SITUACION ESCOLAR*/

                if (this.firma.calificaciones) {
                  let calf = alumno.calificaciones[materia.id][0].promedio;
                  //* Se configuro para que se cancelara los recuadros cuando tienen baja?
                  //this.pdf_registro.text(alumno.calificaciones[materia.id][0].promedio + '', col_mat - tamanio / 2, lineas_alumnos, { align: "center" });
                  if (this.firma.diagonal) {
                    if (calf != '==' && calf != '' && alumno.calificaciones["situacion_escolar"] != 'BT') {
                      this.pdf_registro.text(calf + '', col_mat - tamanio / 2, lineas_alumnos, { align: "center" })

                    } else {
                      this.pdf_registro.line(col_mat - tamanio, lineas_alumnos - 3.2, col_mat, lineas_alumnos);
                    }
                  } else {
                    this.pdf_registro.text(calf + '', col_mat - tamanio / 2, lineas_alumnos, { align: "center" });
                  }
                }
              }
            });

            col_mat = p_al + 8;
            materia_nivel.forEach(materia => {
              var splitTitle = this.pdf_registro.splitTextToSize(materia.nombre, 33);
              col_mat += splitTitle.length == 1 ? 7.13 : splitTitle.length * 4.13;
            });

            this.pdf_registro.setTextColor("black");
            let maximo_reprobado = 0;
            let col_mat_text = col_mat - 3;
            //* evalucion de valores en el array reprobados 
            let reprobadas = [];
            let reprobadas_dos = [];
            let reprobadas_general = [];
            ///// var b = '';
            for (let index = 0; index < letras.length; index++) {
              var letra = letras[index];
              if (alumno.reprobadas.hasOwnProperty(letra)) { //? <-- se compara la key de reprobados con el arreglo de letras

                // // if (alumno.reprobadas[letra].aprobado == null) {
                // // }
                //?<-- se evalua si esta o no marcada la casilla para ver las calificaciones
                if (this.firma.calificaciones) {
                  //? se evalua si la situacion escolar es diferente de las bajas que existen en el sistema
                  if (alumno.calificaciones["situacion_escolar"] != 'BR' && alumno.calificaciones["situacion_escolar"] != 'BT' && alumno.calificaciones["situacion_escolar"] != 'BD') {
                    //? se evalua si la variable es diferente de null
                    if (alumno.reprobadas[letra].aprobado != null) {

                      //? si es asi se inserta el obejto al array reprobadas
                      reprobadas.push({
                        id: letra.toString(),
                        promedio: alumno.reprobadas[letra].promedio,
                        opc: alumno.reprobadas[letra].opciones_calificacion.nombre
                      });
                    } else {

                      //? caso contrario se añade al array reprobadas dos
                      reprobadas_dos.push({
                        id: '-',
                        promedio: '-',
                        opc: '-'
                      });
                    }
                  }
                }
                //? por ultimo se concatena ambos arrays

                reprobadas_general = reprobadas.concat(reprobadas_dos)

                //!NOTA: se llevo acabo este proceso debido a los requisitos presentados 
                //!en caso de no que la primera objeto viniera en null se recorriera el siguiente
              }
            }

            //* impresion en el PDF del array analizado anteriormente
            //? se recorre el array concatenado
            for (let j = 0; j < reprobadas_general.length; j++) {
              const calf_reprobadas = reprobadas_general[j];

              //? se condiciona al numero de columnas admitidas
              if (maximo_reprobado < nuevas_columnas) {

                //? impresion de las variables del objeto
                //? 11-01-2024 -> se ajusto para que la eiqueta de calificacion regularizadas sea visible
                this.pdf_registro.text(calf_reprobadas.id, col_mat_text + 7 + (j * 24), lineas_alumnos, { align: 'center' });
                this.pdf_registro.text(calf_reprobadas.promedio.toString(), col_mat_text + 15 + (j * 24), lineas_alumnos, { align: 'center' });
                this.pdf_registro.setFontSize(9);
                this.pdf_registro.text(calf_reprobadas.opc, col_mat_text + 23.5 + (j * 24), lineas_alumnos, { align: 'center', maxWidth: 33 });
                maximo_reprobado++
              }
            }

            // this.pdf_registro.setTextColor("black");
            // let maximo_reprobado = 0;
            // let col_mat_text = col_mat - 3;
            // letras.forEach(letra => {
            //   if (alumno.reprobadas.hasOwnProperty(letra)) {
            //     if (maximo_reprobado < 3) {
            //       if (alumno.reprobadas[letra].valor_minimo_aprobatorio != null) {
            //         this.pdf_registro.text(letra, col_mat_text + 7, lineas_alumnos, { align: "center" });
            //         this.pdf_registro.text(alumno.reprobadas[letra].promedio + '', col_mat_text + 15, lineas_alumnos, { align: "center" });
            //         this.pdf_registro.text(alumno.reprobadas[letra].opciones_calificacion.nombre, col_mat_text + 23, lineas_alumnos, { align: "center" });

            //         maximo_reprobado++;

            //         col_mat_text += 24;
            //       }
            //     }
            //   }
            // });

            if (alumno.calificaciones["situacion_escolar"] == 'BR' || alumno.calificaciones["situacion_escolar"] == 'BD' || alumno.calificaciones["situacion_escolar"] == 'BT') {
              this.pdf_registro.setTextColor(this.firma.color_calf_t); //red
              let col_mat_blanco = 330 - total_col_cal;
              let left_op = total_col_cal;
              col_mat = col_mat_blanco;
              if (this.firma.situacion_p_se) {
                this.pdf_registro.setLineWidth(0.8);
                this.pdf_registro.setDrawColor(255, 255, 255);
                // for (let key = 0; key < (opcion_calificacion.length * 3) - 1; key++) {
                for (let key = 0; key < (nuevas_columnas * 3) - 1; key++) {
                  col_mat_blanco += 8;
                  this.pdf_registro.line(col_mat_blanco, lineas_alumnos - 2.9 + menos_linea, col_mat_blanco, lineas_alumnos + 1.1 + menos_linea);
                }
                this.pdf_registro.setDrawColor(1, 1, 1);
                this.pdf_registro.setLineWidth(0.1);


                this.pdf_registro.text(alumno.calificaciones["situacion_escolar_descripcion"], col_mat + (left_op / 2), lineas_alumnos, { align: "center" });
              }
            }
            this.pdf_registro.setTextColor("black");

            if (this.firma.situacion_p_na) {
              this.pdf_registro.text(alumno.calificaciones["asignaturas_no_acreditadas"] + "", 333, lineas_alumnos, { align: "left" });
            }
            if (this.firma.situacion_p_se) {
              this.pdf_registro.text(alumno.calificaciones["situacion_escolar"], 340, lineas_alumnos, { align: "left" });
            }
            lineas_alumnos += 4.23;
            menos_linea -= 0.022;
          });
        }
        /////////////// FIN REPITEN

        conteo_lienas += (alumnos_nuevos * 4) + 5;
        this.pdf_registro.setFontSize(10);

        if (footer) {
          footer.forEach(element => {
            let columna = 10;
            let fila = 5;
            let col = 0;
            let fil = 0;
            let col_no = 0;
            let ancho = 0;
            let alto = 0;
            element.estructuras_contenidos.forEach(elem => {
              ancho = 216 * (elem.ancho_porcentaje / 100);
              alto = 279 * (elem.alto_porcentaje / 100);
              col_no = 0;
              if (elem.tipo == "FOTO") {
                this.pdf_registro.addImage(elem.logo, "PNG", columna, fila, ancho, alto, "", "FAST");
              } else {
                try {
                  elem.contenido =
                    "<div style='line-height: 20px;'>" +
                    elem.contenido.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>') +
                    "</div>";

                  this.pdf_registro.fromHTML(elem.contenido, columna, conteo_lienas, {
                    width: ancho + columna
                  });
                } catch (e) {
                  console.log(e);
                }
              }
              columna += ancho + 1;
              col++;

              if (element.columnas == col) {
                col = 0;
                conteo_lienas += alto;
                columna = 5;
                col_no = 1;
              }
            });
            if (col_no == 0) conteo_lienas += alto;
          });
        }
        if (!footer || footer.length == 0) {
          this.pdf_registro.setFontSize(10);

          this.pdf_registro.text("INSCRIPCIÓN O REINSCRIPCIÓN", 66, conteo_lienas, { align: "center" });
          this.pdf_registro.text("ACREDITACIÓN Y REGULARIZACIÓN", 180, conteo_lienas, { align: "center" });
          this.pdf_registro.text("LEGALIZACIÓN DEL DOCUMENTO", 288, conteo_lienas, { align: "center" });

          conteo_lienas += 3;
          this.pdf_registro.setFontSize(8);

          let mitad = (206 - conteo_lienas) / 2;
          this.pdf_registro.setFont("helvetica", "", "bold");
          ////////////////////////////
          this.pdf_registro.setLineWidth(0.1);
          this.pdf_registro.setDrawColor(1, 1, 1);
          this.pdf_registro.setFillColor(255, 255, 255);

          this.pdf_registro.rect(10, conteo_lienas, 108, (206 - conteo_lienas), 'FD');
          this.pdf_registro.line(66, conteo_lienas, 66, 206);
          this.pdf_registro.text("DEPARTAMENTO DE SERVICIOS", 92, conteo_lienas + 3, { align: "center" });
          this.pdf_registro.text("ESCOLARES", 92, conteo_lienas + 6, { align: "center" });
          this.pdf_registro.line(66, conteo_lienas + 8, 118, conteo_lienas + 8);

          //
          this.pdf_registro.line(10, conteo_lienas + mitad, 118, conteo_lienas + mitad);
          this.pdf_registro.line(66, conteo_lienas + mitad - 4, 118, conteo_lienas + mitad - 4);
          this.pdf_registro.line(10, conteo_lienas + mitad + 4, 118, conteo_lienas + mitad + 4);

          this.pdf_registro.text("FECHA:", 69, conteo_lienas + mitad - 1.5, { align: "left" });
          this.pdf_registro.text(this.firma.fecha1, 90, conteo_lienas + mitad - 1.5, { align: "left" });
          this.pdf_registro.text("SELLO DEL PLANTEL", 40, conteo_lienas + mitad + 3, { align: "center" });
          this.pdf_registro.text("FECHA Y SELLO DE VALIDACIÓN", 92, conteo_lienas + mitad + 3, { align: "center" });

          this.pdf_registro.line(10, 198, 118, 198);
          if (this.firma.director_sexo1 == 'H') {
            this.pdf_registro.text("NOMBRE Y FIRMA DEL DIRECTOR", 40, 201.5, { align: "center" });
            this.pdf_registro.text("Y/O RECTOR DEL PLANTEL", 40, 204.5, { align: "center" });
          } else {
            this.pdf_registro.text("NOMBRE Y FIRMA DE LA DIRECTORA", 38, 201.5, { align: "center" });
            this.pdf_registro.text("Y/O RECTORA DEL PLANTEL", 38, 204.5, { align: "center" });
          }
          this.pdf_registro.text("NOMBRE Y FIRMA DE QUIEN VALIDA", 92, 203, { align: "center" });

          if (this.firma.cancelar1) {
            this.pdf_registro.line(10, conteo_lienas, 118, 206);
          }

          ////////////////////////////
          this.pdf_registro.setLineWidth(0.1);
          this.pdf_registro.setDrawColor(1, 1, 1);
          this.pdf_registro.setFillColor(255, 255, 255);

          this.pdf_registro.rect(124, conteo_lienas, 108, (206 - conteo_lienas), 'FD');

          this.pdf_registro.line(180, conteo_lienas, 180, 206);
          this.pdf_registro.text("DEPARTAMENTO DE SERVICIOS", 207, conteo_lienas + 3, { align: "center" });
          this.pdf_registro.text("ESCOLARES", 207, conteo_lienas + 6, { align: "center" });
          this.pdf_registro.line(180, conteo_lienas + 8, 232, conteo_lienas + 8);

          //
          this.pdf_registro.line(124, conteo_lienas + mitad, 232, conteo_lienas + mitad);
          this.pdf_registro.line(180, conteo_lienas + mitad - 4, 232, conteo_lienas + mitad - 4);
          this.pdf_registro.line(124, conteo_lienas + mitad + 4, 232, conteo_lienas + mitad + 4);

          this.pdf_registro.text("FECHA:", 183, conteo_lienas + mitad - 1.5, { align: "left" });
          this.pdf_registro.text(this.firma.fecha2, 203, conteo_lienas + mitad - 1.5, { align: "left" });
          this.pdf_registro.text("SELLO DEL PLANTEL", 150, conteo_lienas + mitad + 3, { align: "center" });
          this.pdf_registro.text("FECHA Y SELLO DE VALIDACIÓN", 206, conteo_lienas + mitad + 3, { align: "center" });

          this.pdf_registro.line(124, 198, 232, 198);

          if (this.firma.director_sexo2 == 'H') {
            this.pdf_registro.text("NOMBRE Y FIRMA DEL DIRECTOR", 150, 201.5, { align: "center" });
            this.pdf_registro.text("Y/O RECTOR DEL PLANTEL", 150, 204.5, { align: "center" });
          } else {
            this.pdf_registro.text("NOMBRE Y FIRMA DE LA DIRECTORA", 151, 201.5, { align: "center" });
            this.pdf_registro.text("Y/O RECTORA DEL PLANTEL", 151, 204.5, { align: "center" });
          }

          this.pdf_registro.text("NOMBRE Y FIRMA DE QUIEN VALIDA", 206, 203, { align: "center" });

          if (this.firma.cancelar2) {
            this.pdf_registro.line(124, conteo_lienas, 232, 206);
          }

          ////////////////////////////
          this.pdf_registro.setLineWidth(0.1);
          this.pdf_registro.setDrawColor(1, 1, 1);
          this.pdf_registro.setFillColor(255, 255, 255);
          this.pdf_registro.rect(238, conteo_lienas, 108, (206 - conteo_lienas), 'FD');
          this.pdf_registro.line(294, conteo_lienas + mitad + 4, 294, 206);

          this.pdf_registro.text("DEPARTAMENTO DE SERVICIOS ESCOLARES", 292, conteo_lienas + 4, { align: "center" });
          this.pdf_registro.line(238, conteo_lienas + 8, 346, conteo_lienas + 8);

          this.pdf_registro.text("PERIODO LEGALIZADO", 292, conteo_lienas + 11.5, { align: "center" });
          this.pdf_registro.text(data.periodos_escolares.nombre, 292, conteo_lienas + 14, { align: "center" });
          this.pdf_registro.line(238, conteo_lienas + 16, 346, conteo_lienas + 16);

          this.pdf_registro.line(238, conteo_lienas + mitad - 4, 346, conteo_lienas + mitad - 4);
          this.pdf_registro.line(238, conteo_lienas + mitad + 4, 346, conteo_lienas + mitad + 4);

          this.pdf_registro.text("FECHA:", 240, conteo_lienas + mitad + 1.5, { align: "left" });
          this.pdf_registro.text(this.firma.fecha3, 260, conteo_lienas + mitad + 1.5, { align: "left" });

          this.pdf_registro.line(238, 198, 346, 198);
          if (this.firma.jefe_sexo1 == 'H') {
            this.pdf_registro.text("NOMBRE Y FIRMA DEL JEFE", 266, 201.5, { align: "center" });
          } else {
            this.pdf_registro.text("NOMBRE Y FIRMA DE LA JEFA", 266, 201.5, { align: "center" });
          }
          this.pdf_registro.text("DE OFICINA", 266, 204.5, { align: "center" });

          if (this.firma.jefe_sexo2 == 'H') {
            this.pdf_registro.text("NOMBRE Y FIRMA DEL JEFE", 320, 201.5, { align: "center" });
          } else {
            this.pdf_registro.text("NOMBRE Y FIRMA DE LA JEFA", 320, 201.5, { align: "center" });
          }
          this.pdf_registro.text("DEL DEPTO.", 320, 204.5, { align: "center" });

          if (this.firma.cancelar3) {
            this.pdf_registro.line(238, conteo_lienas, 346, 206);
          }

          //////////////////////////////////////////////////////////////////////////////////

          this.pdf_registro.setFont("helvetica", "", "normal");
          if (this.firma.director1.search(",") > -1) {
            this.pdf_registro.text(this.firma.director1.split(",")[0], 40, 193, { align: "center" });
            this.pdf_registro.text(this.firma.director1.split(",")[1], 40, 196, { align: "center" });
          } else {
            this.pdf_registro.text(this.firma.director1, 40, 196, { align: "center" });
          }
          if (this.firma.valida1.search(",") > -1) {
            this.pdf_registro.text(this.firma.valida1.split(",")[0], 92, 193, { align: "center" });
            this.pdf_registro.text(this.firma.valida1.split(",")[1], 92, 196, { align: "center" });
          } else {
            this.pdf_registro.text(this.firma.valida1, 92, 196, { align: "center" });
          }
          ////////////////
          if (this.firma.director2.search(",") > -1) {
            this.pdf_registro.text(this.firma.director2.split(",")[0], 150, 193, { align: "center" });
            this.pdf_registro.text(this.firma.director2.split(",")[1], 150, 196, { align: "center" });
          } else {
            this.pdf_registro.text(this.firma.director2, 150, 196, { align: "center" });
          }
          if (this.firma.valida2.search(",") > -1) {
            this.pdf_registro.text(this.firma.valida2.split(",")[0], 206, 193, { align: "center" });
            this.pdf_registro.text(this.firma.valida2.split(",")[1], 206, 196, { align: "center" });
          } else {
            this.pdf_registro.text(this.firma.valida2, 206, 196, { align: "center" });
          }
          ////////////////
          if (this.firma.jefe1.search(",") > -1) {
            this.pdf_registro.text(this.firma.jefe1.split(",")[0], 266, 193, { align: "center" });
            this.pdf_registro.text(this.firma.jefe1.split(",")[1], 266, 196, { align: "center" });
          } else {
            this.pdf_registro.text(this.firma.jefe1, 266, 196, { align: "center" });
          }
          if (this.firma.jefe2.search(",") > -1) {
            this.pdf_registro.text(this.firma.jefe2.split(",")[0], 320, 193, { align: "center" });
            this.pdf_registro.text(this.firma.jefe2.split(",")[1], 320, 196, { align: "center" });
          } else {
            this.pdf_registro.text(this.firma.jefe2, 320, 196, { align: "center" });
          }
        }

        if (hojas < this.dato.length) {
          let conteo_lienas = 5;
          this.pdf_registro.addPage();
        }
      });

      this.cargando = false;
      // this.pdf_registro.autoPrint();
      window.open(this.pdf_registro.output('bloburl'), '_blank');
      /*const string = this.pdf_registro.output("datauristring", "registro_escolaridad.pdf");

      const object =
        "<object border='0' style='border:0px' width='100%' height='100%' data='" +
        string +
        "'></object>";

      const x = window.open();
      x.document.open();
      x.document.write(object);
      x.document.close();*/

    }, 10);
  }







  cabecera_alumnos_licenciatura(data, conteo_lienas, p_al, opcion_calificacion, materia_nivel, total_col_cal, tam_rec, tam_lin_ver, tam_mat, tamanio_materia, nuevas_columnas) {
    ///////////////////////// ANTECEDENTES ///////////////////////////////////////
    let c = 0;
    this.pdf_registro.setFont("helvetica", "", "bold");
    this.pdf_registro.setFontSize(8);
    this.pdf_registro.setLineWidth(0.5);
    this.pdf_registro.setDrawColor(1, 1, 1);
    this.pdf_registro.setFillColor(255, 255, 255);
    this.pdf_registro.rect(10, conteo_lienas - 1.5, 336, tam_rec + 1.5, 'FD');
    conteo_lienas += 5;
    this.pdf_registro.line(18, conteo_lienas - 2.5, 18, tam_lin_ver);
    this.pdf_registro.text("NUMERO PROGRESIVO", 14.5, conteo_lienas + 34, { align: "left", angle: 90 });
    this.pdf_registro.setLineWidth(0.1);

    this.pdf_registro.line(26, conteo_lienas - 2.5, 26, tam_lin_ver);
    this.pdf_registro.text("ASIGNATURAS NO", 21.5, conteo_lienas + 34, { align: "left", angle: 90 });
    this.pdf_registro.text("ACREDITADAS", 24.5, conteo_lienas + 34, { align: "left", angle: 90 });

    this.pdf_registro.line(10, conteo_lienas - 2.5, 34.5, conteo_lienas - 2.5);
    this.pdf_registro.setFontSize(7);
    this.pdf_registro.text("ANTECENDENTES", 21.5, conteo_lienas - 3.3, { align: "center" });
    this.pdf_registro.setFontSize(8);

    this.pdf_registro.setLineWidth(0.5);

    this.pdf_registro.line(34.5, conteo_lienas - 6.5, 34.5, tam_lin_ver);
    this.pdf_registro.text("SITUACIÓN ESCOLAR", 31, conteo_lienas + 34, { align: "left", angle: 90 });

    ///////////////////////// NUMERO DE CONTROL ///////////////////////////////////////

    this.pdf_registro.line(50, conteo_lienas - 6.5, 50, tam_lin_ver);
    this.pdf_registro.text("NÚMERO", 42, conteo_lienas + 2, { align: "center" });
    this.pdf_registro.text("DE", 42, conteo_lienas + 8, { align: "center" });
    this.pdf_registro.text("CONTROL", 42, conteo_lienas + 14, { align: "center" });
    this.pdf_registro.text("CLAVE", 42, conteo_lienas + 23, { align: "center" });
    this.pdf_registro.text("D.S.E", 42, conteo_lienas + 28, { align: "center" });
    this.pdf_registro.text(data.alumnos[0].matricula.substr(0, 4), 42, conteo_lienas + 33, { align: "center" });
    this.pdf_registro.setLineWidth(0.1);

    ///////////////////////// ALUMNO ///////////////////////////////////////

    this.pdf_registro.text("NOMBRE DEL ALUMNO", 26 + (p_al) / 2, conteo_lienas + 15, { align: "center" });
    let tam_l = 2.5;
    let left_mas = (p_al / 3) - 23;
    if (p_al < 155) left_mas = (p_al / 3) - 28;
    this.pdf_registro.line(50, conteo_lienas + 29, p_al + 2, conteo_lienas + 29);
    this.pdf_registro.text("AP. PATERNO", 52, conteo_lienas + 33, { align: "left" });
    this.pdf_registro.text("AP. MATERNO", 52 + left_mas, conteo_lienas + 33, { align: "left" });
    this.pdf_registro.text("NOMBRE(S)", 52 + (left_mas * 2), conteo_lienas + 33, { align: "left" });
    this.pdf_registro.setLineWidth(0.5);

    this.pdf_registro.line(p_al + 2, conteo_lienas - 6.5, p_al + 2, tam_lin_ver);
    this.pdf_registro.text("SEXO", p_al + 6, conteo_lienas + 34, { align: "left", angle: 90 });
    this.pdf_registro.line(p_al + 8, conteo_lienas - 6.5, p_al + 8, tam_lin_ver);
    this.pdf_registro.setLineWidth(0.1);

    let conteo_linea_sup = conteo_lienas - 6.5;

    ///////////////////////// MATERIAS ///////////////////////////////////////
    this.pdf_registro.setFont("helvetica", "", "bold");
    let letras = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L"];

    let caf_col = 330;
    let caf_fin = caf_col - total_col_cal - (tam_mat / 2);
    let reg_col = caf_col - total_col_cal;
    // linea titulo calificaciones
    this.pdf_registro.line(p_al + 8, conteo_linea_sup + 4, caf_col, conteo_linea_sup + 4);
    // linea letras
    this.pdf_registro.line(p_al + 8, conteo_linea_sup + 7.5, reg_col, conteo_linea_sup + 7.5);

    this.pdf_registro.text("CALIFICACIONES FINALES", caf_fin, conteo_linea_sup + 3, { align: "center" });
    this.pdf_registro.text("CALIFICACIONES DE REGULARIZACIÓN", caf_col - (total_col_cal / 2), conteo_linea_sup + 3, { align: "center" });

    let col_mat = p_al + 8;
    let col_mat_text = col_mat;

    conteo_linea_sup += 6.5;
    this.pdf_registro.setFont("helvetica", "", "normal");
    let ct = 0;
    materia_nivel.forEach((materia, key) => {
      var splitTitle = this.pdf_registro.splitTextToSize(materia.nombre, 33);
      let tamanio = tamanio_materia[key];
      col_mat += tamanio;

      this.pdf_registro.text(letras[key], col_mat - (tamanio / 2), conteo_linea_sup + 0.5, { align: "center" });
      this.pdf_registro.text(splitTitle, col_mat_text + 4, conteo_linea_sup + 34.4, 90, { align: "left" });

      ct = conteo_linea_sup - 6.5;
      if (key != materia_nivel.length - 1) {
        ct = conteo_linea_sup - 2.5;
      }
      if (key < materia_nivel.length - 1) {
        this.pdf_registro.line(col_mat, ct, col_mat, tam_lin_ver);
      }
      col_mat_text += tamanio;
    });

    this.pdf_registro.setLineWidth(0.5);
    this.pdf_registro.line(330 - total_col_cal, ct, 330 - total_col_cal, tam_lin_ver);
    this.pdf_registro.setLineWidth(0.1);

    ct = 0;
    col_mat = 330 - total_col_cal;
    // for (let key = 0; key < (opcion_calificacion.length * 3); key++) {
    for (let key = 0; key < (nuevas_columnas * 3); key++) {
      col_mat += 8;

      ct = conteo_linea_sup - 6.5;
      // if (key != (opcion_calificacion.length * 3) - 1)
      if (key != (nuevas_columnas * 3) - 1)
        ct = conteo_linea_sup - 2.5;
      this.pdf_registro.line(col_mat, ct, col_mat, tam_lin_ver);
    }

    col_mat_text = 330 - total_col_cal - 3;
    // for (let key = 0; key < opcion_calificacion.length; key++) {
    for (let key = 0; key < nuevas_columnas; key++) {
      this.pdf_registro.text("CLAVE MATERIA", col_mat_text + 8, conteo_linea_sup + 34.3, { align: "left", angle: 90 });
      this.pdf_registro.text("CALIFICACIÓN", col_mat_text + 16, conteo_linea_sup + 34.3, { align: "left", angle: 90 });
      this.pdf_registro.text("TIPO DE EXAMEN", col_mat_text + 24, conteo_linea_sup + 34.3, { align: "left", angle: 90 });

      col_mat_text += 24;
    }
    this.pdf_registro.setFont("helvetica", "", "bold");
    this.pdf_registro.setLineWidth(0.5);

    col_mat = 330;
    this.pdf_registro.line(col_mat, ct, col_mat, tam_lin_ver);

    this.pdf_registro.text("ASIGNATURAS NO", col_mat + 3.3, conteo_linea_sup + 34, { align: "left", angle: 90 });
    this.pdf_registro.text("ACREDITADAS", col_mat + 6.3, conteo_linea_sup + 34, { align: "left", angle: 90 });

    this.pdf_registro.line(col_mat + 8, conteo_linea_sup - 6.5, col_mat + 8, tam_lin_ver);
    this.pdf_registro.text("SITUACIÓN ESCOLAR", col_mat + 13, conteo_linea_sup + 34, { align: "left", angle: 90 });
  }

  alumnos_lineas_licenciatura(lineas, conteo_lienas, p_al, opcion_calificacion, materia_nivel, total_col_cal, tam_mat, tamanio_materia, nuevas_columnas) {
    this.pdf_registro.setLineWidth(0.5);
    this.pdf_registro.setDrawColor(1, 1, 1);
    this.pdf_registro.setFillColor(255, 255, 255);

    let tam_lin_ver = lineas * 4;

    this.pdf_registro.rect(10, conteo_lienas, 336, tam_lin_ver, 'FD');
    tam_lin_ver = (tam_lin_ver + conteo_lienas);
    this.pdf_registro.line(18, conteo_lienas, 18, tam_lin_ver);

    this.pdf_registro.setLineWidth(0.1);

    this.pdf_registro.line(26, conteo_lienas, 26, tam_lin_ver);

    this.pdf_registro.setLineWidth(0.5);
    this.pdf_registro.line(35, conteo_lienas, 35, tam_lin_ver);
    this.pdf_registro.line(50, conteo_lienas, 50, tam_lin_ver);


    this.pdf_registro.line(p_al + 2, conteo_lienas, p_al + 2, tam_lin_ver);
    this.pdf_registro.line(p_al + 8, conteo_lienas, p_al + 8, tam_lin_ver);

    this.pdf_registro.setLineWidth(0.1);

    let ct = conteo_lienas;
    let col_mat = p_al + 8;
    let col_mat_text = col_mat;
    materia_nivel.forEach((materia, key) => {
      var splitTitle = this.pdf_registro.splitTextToSize(materia.nombre, 33);
      let tamanio = tamanio_materia[key];
      col_mat += tamanio;

      if (key < materia_nivel.length - 1) {
        this.pdf_registro.line(col_mat, ct, col_mat, tam_lin_ver);
      }
      col_mat_text += tamanio;
    });

    this.pdf_registro.setLineWidth(0.5);
    this.pdf_registro.line(330 - total_col_cal, ct, 330 - total_col_cal, tam_lin_ver);
    this.pdf_registro.setLineWidth(0.1);

    //////////////
    ct = conteo_lienas;
    col_mat = 330 - total_col_cal;
    // for (let key = 0; key < (opcion_calificacion.length * 3); key++) {
    // for (let key = 0; key < (opcion_calificacion.length * 3); key++) {
    for (let key = 0; key < (nuevas_columnas * 3); key++) {
      col_mat += 8;

      this.pdf_registro.line(col_mat, ct, col_mat, tam_lin_ver);
    }

    col_mat = 330;
    this.pdf_registro.setLineWidth(0.5);
    this.pdf_registro.line(col_mat, ct, col_mat, tam_lin_ver);
    this.pdf_registro.line(col_mat + 8, ct, col_mat + 8, tam_lin_ver);
    /////////////

    let lineas_alumnos = conteo_lienas + 4;

    this.pdf_registro.setLineWidth(0.1);
    for (let i = 0; i < lineas; i++) {
      this.pdf_registro.line(10, lineas_alumnos, 346, lineas_alumnos);
      lineas_alumnos += 4;
    }
  }


  imprimirRegistroPosgrado() {    
    //let document_name = "REGISTRO ESCOLARIDAD " + this.configuracion.nivel_educativo.nombre.toUpperCase();
   // let document_name = "REGISTRO_ESCOLAR";
    let document_name = "REGISTRO_ESCOLAR";
    let header = this.documentos[document_name]["HEADER"];
    let footer = this.documentos[document_name]["FOOTER"];

    let personas_firman = this.firma;
    localStorage.setItem('Nombre_Firma_' + this.configuracion.nivel_educativo.nombre, JSON.stringify(personas_firman));

    this.cargando = true;

    setTimeout(() => {
      this.pdf_registro = new jsPDF('l', 'mm', [612, 1008]); // 216 X 356
      this.pdf_registro.setFont("helvetica");
      this.pdf_registro.setFontSize(10);
      this.pdf_registro.setFont("helvetica", "", "bold");
      let pagina = this.dato.length;
      let hojas = 0;
      let num_alumnos = 0;
      let nuevas_columnas = 0
      this.dato.forEach((data, contador) => {
        hojas++;
        let conteo_lienas = 5;
        if (header) {
          header.forEach(element => {
            let columna = 5;
            let fila = 5;
            let col = 0;
            let fil = 0;
            let col_no = 0;
            let ancho = 0;
            let alto = 0;
            element.estructuras_contenidos.forEach(elem => {
              ancho = 216 * (elem.ancho_porcentaje / 100);
              alto = 279 * (elem.alto_porcentaje / 100);
              col_no = 0;
              if (elem.tipo == "FOTO") {
                this.pdf_registro.addImage(
                  elem.logo,
                  "PNG",
                  columna,
                  fila,
                  ancho,
                  alto,
                  "",
                  "FAST"
                );
              } else {
                try {
                  elem.contenido =
                    "<div style='line-height: 20px;'>" +
                    elem.contenido.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>') +
                    "</div>";

                  this.pdf_registro.fromHTML(elem.contenido, columna, conteo_lienas, {
                    width: ancho + columna
                  });
                } catch (e) {
                  console.log(e);
                }
              }
              columna += ancho + 1;
              col++;
            });
          });
        }

        this.pdf_registro.setFont("helvetica");
        this.pdf_registro.setFontSize(10);
        this.pdf_registro.setFont("helvetica", "", "bold");

        this.pdf_registro.setLineWidth(0.1);
        this.pdf_registro.setDrawColor(1, 1, 1);
        this.pdf_registro.setFillColor(255, 255, 255);

        ////////////////////// ESTADISTICA //////////////////////////////////////

        this.pdf_registro.rect(290, conteo_lienas, 56, 32, 'FD');

        this.pdf_registro.line(290, conteo_lienas + 4, 346, conteo_lienas + 4);
        this.pdf_registro.line(290, conteo_lienas + 21, 346, conteo_lienas + 21);
        this.pdf_registro.line(290, conteo_lienas + 26.5, 346, conteo_lienas + 26.5);

        this.pdf_registro.line(319, conteo_lienas + 4, 319, conteo_lienas + 32);
        this.pdf_registro.line(328, conteo_lienas + 4, 328, conteo_lienas + 32);
        this.pdf_registro.line(337, conteo_lienas + 4, 337, conteo_lienas + 32);

        this.pdf_registro.setFontSize(8);
        this.pdf_registro.text("DATOS ESTADISTICOS", 322, conteo_lienas + 3, { align: 'center' });
        this.pdf_registro.text("CONCEPTO", 292, conteo_lienas + 13, { align: 'left' });
        this.pdf_registro.text("INICIO DE CURSO", 292, conteo_lienas + 24.5, { align: 'left' });
        this.pdf_registro.text("FIN DE CURSO", 292, conteo_lienas + 30, { align: 'left' });

        this.pdf_registro.text('HOMBRES', 325, conteo_lienas + 20, { align: 'left', angle: 90 });
        this.pdf_registro.text('MUJERES', 334, conteo_lienas + 20, { align: 'left', angle: 90 });
        this.pdf_registro.text('TOTAL', 342, conteo_lienas + 20, { align: 'left', angle: 90 });

        this.pdf_registro.text((data.total_hombres_inicio + data.total_hombres_repiten_curso) + '', 323, conteo_lienas + 24.5, { align: 'left' });
        this.pdf_registro.text((data.total_mujeres_inicio + data.total_mujeres_repiten_curso) + '', 331, conteo_lienas + 24.5, { align: 'left' });
        this.pdf_registro.text((data.total_hombres_inicio + data.total_mujeres_inicio + data.total_hombres_repiten_curso + data.total_mujeres_repiten_curso) + '', 340, conteo_lienas + 24.5, { align: 'left' });

        if (this.firma.fin_curso) {
          this.pdf_registro.text((data.total_hombres+data.total_hombres_repiten_curso) + '', 323, conteo_lienas + 30, { align: 'left' });
          this.pdf_registro.text((data.total_mujeres+data.total_mujeres_repiten_curso) + '', 331, conteo_lienas + 30, { align: 'left' });
          this.pdf_registro.text((data.total_hombres + data.total_mujeres + data.total_hombres_repiten_curso + data.total_mujeres_repiten_curso) + '', 340, conteo_lienas + 30, { align: 'left' });
        }

        // this.pdf_registro.text((data.total_hombres_inicio + data.total_hombres_repiten_curso) + '', 323, conteo_lienas + 24.5, { align: 'left' });
        // this.pdf_registro.text((data.total_mujeres_inicio + data.total_mujeres_repiten_curso) + '', 331, conteo_lienas + 24.5, { align: 'left' });
        // this.pdf_registro.text((data.total_hombres_inicio + data.total_mujeres_inicio) + '', 340, conteo_lienas + 24.5, { align: 'left' });

        // if (this.firma.fin_curso) {
        //   this.pdf_registro.text((data.total_hombres + data.total_hombres_repiten_curso) + '', 323, conteo_lienas + 30, { align: 'left' });
        //   this.pdf_registro.text((data.total_mujeres + data.total_mujeres_repiten_curso) + '', 331, conteo_lienas + 30, { align: 'left' });
        //   this.pdf_registro.text((data.total_hombres + data.total_mujeres + data.total_hombres_repiten_curso) + '', 340, conteo_lienas + 30, { align: 'left' });
        // }

        this.pdf_registro.setFontSize(10);
        conteo_lienas += 38;

        //////////////////////// ESCUELA ////////////////////////////////////

        this.pdf_registro.text("ESCUELA:", 10, conteo_lienas, { align: "left" });
        this.pdf_registro.line(34, conteo_lienas + 1, 165, conteo_lienas + 1);

        this.pdf_registro.text("LOCALIDAD:", 10, conteo_lienas + 5, { align: "left" });
        this.pdf_registro.line(34, conteo_lienas + 6, 165, conteo_lienas + 6);

        this.pdf_registro.text("CARRERA:", 10, conteo_lienas + 10, { align: "left" });
        this.pdf_registro.line(34, conteo_lienas + 11, 165, conteo_lienas + 11);

        this.pdf_registro.text("MODALIDAD:", 10, conteo_lienas + 15, { align: "left" });
        this.pdf_registro.line(34, conteo_lienas + 16, 165, conteo_lienas + 16);

        this.pdf_registro.setFont("helvetica", "", "normal");

        this.pdf_registro.text(this.configuracion.empresa.nombre + " " + this.configuracion.empresa.subnombre, 36, conteo_lienas, { align: "left" });
        this.pdf_registro.text(this.configuracion.sucursal.direccion.split(",")[1].toUpperCase().trim(), 36, conteo_lienas + 5, { align: "left" });
        this.pdf_registro.text(data.carreras_planes.carreras.nombre, 36, conteo_lienas + 10, { align: "left" });
        this.pdf_registro.text(data.periodos_escolares.modalidades.nombre_imprimir, 36, conteo_lienas + 15, { align: "left" });

        this.pdf_registro.setFont("helvetica", "", "bold");

        //////////////////////// CLAVE ////////////////////////////////////

        this.pdf_registro.text("CLAVE:", 170, conteo_lienas, { align: "left" });
        this.pdf_registro.line(190, conteo_lienas + 1, 240, conteo_lienas + 1);

        this.pdf_registro.text("TURNO:", 170, conteo_lienas + 5, { align: "left" });
        this.pdf_registro.line(190, conteo_lienas + 6, 240, conteo_lienas + 6);

        this.pdf_registro.text("RVOE:", 170, conteo_lienas + 10, { align: "left" });
        this.pdf_registro.line(190, conteo_lienas + 11, 240, conteo_lienas + 11);
        if (data.carreras_planes.vigente_desde) {
          this.pdf_registro.text("VIGENTE:", 170, conteo_lienas + 15, { align: "left" });
          this.pdf_registro.line(190, conteo_lienas + 16, 290, conteo_lienas + 16);
        }

        this.pdf_registro.setFont("helvetica", "", "normal");
        this.pdf_registro.text(this.configuracion.sucursal.clave, 192, conteo_lienas, { align: "left" });
        this.pdf_registro.text(data.turnos.nombre, 192, conteo_lienas + 5, { align: "left" });
        this.pdf_registro.text(data.carreras_planes.rvoe, 192, conteo_lienas + 10, { align: "left" });
        this.pdf_registro.text(data.carreras_planes.vigente_desde ? data.carreras_planes.vigente_desde : "", 192, conteo_lienas + 15, { align: "left" });
        this.pdf_registro.setFont("helvetica", "", "bold");

        /////////////////////// CICLO ESCOLAR /////////////////////////////////////
        let anio_actual = data.periodos_escolares.fecha_inicio.substr(0, 4);
        let anio_anterior = anio_actual - 1;
        this.pdf_registro.text("CICLO ESCOLAR:", 245, conteo_lienas, { align: "left" });
        this.pdf_registro.line(282, conteo_lienas + 1, 346, conteo_lienas + 1);

        this.pdf_registro.text(data.periodos_escolares.tipos_periodos.nombre + ":", 245, conteo_lienas + 5, { align: "left" });
        this.pdf_registro.line(282, conteo_lienas + 6, 310, conteo_lienas + 6);

        this.pdf_registro.text("GRUPO:", 312, conteo_lienas + 5, { align: "left" });
        this.pdf_registro.line(325, conteo_lienas + 6, 346, conteo_lienas + 6);

        this.pdf_registro.text("PERIODO ESCOLAR:", 245, conteo_lienas + 10, { align: "left" });
        this.pdf_registro.line(282, conteo_lienas + 11, 346, conteo_lienas + 11);

        this.pdf_registro.setFont("helvetica", "", "normal");
        this.pdf_registro.text(data.periodos_escolares.ciclos_escolares ? data.periodos_escolares.ciclos_escolares.nombre : '', 284, conteo_lienas, { align: "left" });
        this.pdf_registro.text(data.nivel + "", 284, conteo_lienas + 5, { align: "left" });
        this.pdf_registro.text(data.identificador, 327, conteo_lienas + 5, { align: "left" });
        this.pdf_registro.text(data.periodos_escolares.nombre, 284, conteo_lienas + 10, { align: "left" });
        this.pdf_registro.setFont("helvetica", "", "bold");

        let total_alumnos = data.alumnos.length;

        this.pdf_registro.text("HOJA:", 295, conteo_lienas + 15, { align: "left" });
        this.pdf_registro.line(308, conteo_lienas + 16, 318, conteo_lienas + 16);
        this.pdf_registro.text(hojas + "", 312, conteo_lienas + 15, { align: "left" });

        this.pdf_registro.text("DE:", 322, conteo_lienas + 15, { align: "left" });
        this.pdf_registro.line(332, conteo_lienas + 16, 346, conteo_lienas + 16);
        this.pdf_registro.text(pagina + "", 337, conteo_lienas + 15, { align: "left" });

        conteo_lienas += 20;

        let materia_nivel = [];
        data.carreras_planes.materias.forEach(materia => {
          if (materia.nivel == data.nivel) {
            materia_nivel.push(materia);
          }
        });

        nuevas_columnas = Math.round(materia_nivel.length / 2);
        if (materia_nivel.length < 6) {
          let mas_materia = 6 - materia_nivel.length;
          for (let mi = 0; mi < mas_materia; mi++) {
            materia_nivel.push({
              carreras_planes_id: "",
              categorias_materias_id: "",
              causa_reprobacion: "",
              clave: "",
              creado_por: "",
              creditos: '',
              deleted_at: '',
              es_practica: 0,
              hd: '',
              hi: '',
              id: "",
              imprimible_alumno: '',
              imprimible_boleta: '',
              materia_anterior: '',
              modificado_por: "",
              nivel: '',
              nombre: "",
              orden: '',
              porcentaje_valor: 0
            });
          }
        }

        let opcion_calificacion = [];
        data.carreras_planes.opciones_calificacion.forEach(opcion => {
          if (opcion.modalidades_id == data.periodos_escolares.modalidades_id) {
            opcion_calificacion.push(opcion);
          }
        });

        let tam_mat = 0; let tamanio_materia = [];
        materia_nivel.forEach((materia, key) => {
          var splitTitle = this.pdf_registro.splitTextToSize(materia.nombre, 33);
          let suma_texto = 0, tamano_texto = 1;
          splitTitle.forEach(texto => {
            if (texto.length + suma_texto >= 33) {
              tamano_texto++;
              suma_texto = 0;
            } else {
              suma_texto += 33;
            }
          });
          if (suma_texto > 0) {
            tamano_texto++;
          }
          if (tamano_texto < splitTitle.length) {
            tamano_texto = splitTitle.length;
          }
          if (materia_nivel.length == 3) {
            tamanio_materia[key] = 15;
          } else if (materia_nivel.length == 2) {
            tamanio_materia[key] = 20;
          } else if (materia_nivel.length == 1) {
            tamanio_materia[key] = 40;
          } else {
            tamanio_materia[key] = splitTitle.length == 1 ? 8 : (tamano_texto * 3.2) + 2;
          }
          tam_mat += tamanio_materia[key];
        });

        let conteo_columnas = 0;
        // let total_col_cal = ((opcion_calificacion.length * 3) * 8);
        let total_col_cal = ((nuevas_columnas * 3) * 8);
        let num_columns = 330;

        let p_al = 330 - total_col_cal;
        p_al = p_al - tam_mat - 8;
        this.pdf_registro.setFontSize(10);

        this.cabecera_alumnos_licenciatura(data, conteo_lienas, p_al, opcion_calificacion, materia_nivel, total_col_cal, 145, 207.5, tam_mat, tamanio_materia, nuevas_columnas);

        this.pdf_registro.setFontSize(10);
        conteo_lienas += 40;

        let lineas_alumnos = conteo_lienas;
        this.pdf_registro.setLineWidth(0.5);
        for (let i = 1; i < 26; i++) {
          this.pdf_registro.line(10, lineas_alumnos, 346, lineas_alumnos);
          this.pdf_registro.setLineWidth(0.1);
          this.pdf_registro.text((i + num_alumnos) + "", 13.5, lineas_alumnos + 3, { align: "center" });
          lineas_alumnos += 4.2;
        }
        num_alumnos += 25;

        lineas_alumnos = conteo_lienas + 3;

        //////////////// INFORMACION ALUMNOS /////////////////////
        let letras = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L"];
        this.pdf_registro.setFont("helvetica", "", "normal");
        let menos_linea = 0;
        data.alumnos.forEach((alumno, key) => {
          this.pdf_registro.setTextColor("black");

          if (alumno.id == '99ff2e5aa51bc2341f2bab473bc8349c') {
            console.log(alumno.nombre + ' ' + alumno.apellido_paterno);
            alumno.calificaciones["situacion_escolar_antes"] = "P"
          }
          if (this.firma.situacion_a_na) {
            this.pdf_registro.text(alumno.calificaciones["asignaturas_no_acreditadas_antes"] + "", 21, lineas_alumnos, { align: "left" });
          }
          if (this.firma.situacion_a_se) {
            this.pdf_registro.text(alumno.calificaciones["situacion_escolar_antes"], 29, lineas_alumnos, { align: "left" });
          }
          this.pdf_registro.text(alumno.matricula.substr(4, alumno.matricula.length), 43, lineas_alumnos, { align: "center" });

          this.pdf_registro.text(alumno.apellido_paterno + " " + alumno.apellido_materno + " " + alumno.nombre, 52, lineas_alumnos, { align: "left" });

          this.pdf_registro.text(alumno.sexo, p_al + 5, lineas_alumnos, { align: "center" });

          let col_mat = p_al + 8;
          // calificaciones
          materia_nivel.forEach((materia, key) => {
            var splitTitle = this.pdf_registro.splitTextToSize(materia.nombre, 33);
            let tamanio = tamanio_materia[key];
            col_mat += tamanio;
            if (alumno.calificaciones.hasOwnProperty(materia.id)) {
              if (alumno.calificaciones[materia.id][0].promedio < alumno.calificaciones[materia.id][0].valor_minimo_aprobatorio)
                this.pdf_registro.setTextColor(this.firma.color_calf_r); // red
              else
                this.pdf_registro.setTextColor("black");
              this.pdf_registro.setFontSize(10);/* SE PUSO ESTA FUENTE PARA NO MODIFICAR LAS CALF Y SITUACION ESCOLAR*/

              if (this.firma.calificaciones) {
                let calf = alumno.calificaciones[materia.id][0].promedio;

                if (alumno.calificaciones["situacion_escolar"] == 'BD') {
                  calf = ''
                }
                if (this.firma.diagonal) {


                  // if (alumno.calificaciones["situacion_escolar"] == 'BT') {
                  //   this.pdf_registro.line(col_mat - tamanio, lineas_alumnos - 3.2, col_mat, lineas_alumnos + 1);
                  //   //this.pdf_registro.setTextColor(255,255,255);
                  //   //this.pdf_registro.text( ' ',col_mat - tamanio / 2, lineas_alumnos, {align:"center"});
                  // }
                  if (calf != '==' && calf != '' && alumno.calificaciones["situacion_escolar"] != 'BT' && alumno.calificaciones["situacion_escolar"] != 'BD') {
                    this.pdf_registro.text(calf + '', col_mat - tamanio / 2, lineas_alumnos, { align: "center" });
                  } else {
                    this.pdf_registro.line(col_mat - tamanio, lineas_alumnos - 3.2, col_mat, lineas_alumnos + 1);
                  }

                } else {
                  this.pdf_registro.text(calf + '', col_mat - tamanio / 2, lineas_alumnos, { align: "center" });
                }

              }
            }
          });

          this.pdf_registro.setTextColor("black");

          col_mat = p_al + 8;
          materia_nivel.forEach(materia => {
            var splitTitle = this.pdf_registro.splitTextToSize(materia.nombre, 33);
            col_mat += splitTitle.length == 1 ? 7.13 : splitTitle.length * 4.13;
          });

          this.pdf_registro.setTextColor("black");
          let maximo_reprobado = 0;
          let col_mat_text = col_mat - 3;
          //* evalucion de valores en el array reprobados 
          let reprobadas = [];
          let reprobadas_dos = [];
          let reprobadas_general = [];
          ///// var b = '';
          for (let index = 0; index < letras.length; index++) {
            var letra = letras[index];
            if (alumno.reprobadas.hasOwnProperty(letra)) { //? <-- se compara la key de reprobados con el arreglo de letras

              // // if (alumno.reprobadas[letra].aprobado == null) {
              // // }
              //?<-- se evalua si esta o no marcada la casilla para ver las calificaciones
              if (this.firma.calificaciones) {
                //? se evalua si la situacion escolar es diferente de las bajas que existen en el sistema
                if (alumno.calificaciones["situacion_escolar"] != 'BR' && alumno.calificaciones["situacion_escolar"] != 'BT' && alumno.calificaciones["situacion_escolar"] != 'BD') {
                  //? se evalua si la variable es diferente de null
                  if (alumno.reprobadas[letra].aprobado != null) {

                    //? si es asi se inserta el obejto al array reprobadas
                    reprobadas.push({
                      id: letra.toString(),
                      promedio: alumno.reprobadas[letra].promedio,
                      opc: alumno.reprobadas[letra].opciones_calificacion.nombre
                    });
                  } else {

                    //? caso contrario se añade al array reprobadas dos
                    reprobadas_dos.push({
                      id: '-',
                      promedio: '-',
                      opc: '-'
                    });
                  }
                }
              }
              //? por ultimo se concatena ambos arrays

              reprobadas_general = reprobadas.concat(reprobadas_dos)

              //!NOTA: se llevo acabo este proceso debido a los requisitos presentados 
              //!en caso de no que la primera objeto viniera en null se recorriera el siguiente
            }
          }

          //* impresion en el PDF del array analizado anteriormente
          //? se recorre el array concatenado
          for (let j = 0; j < reprobadas_general.length; j++) {
            const calf_reprobadas = reprobadas_general[j];

            //? se condiciona al numero de columnas admitidas
            if (maximo_reprobado < nuevas_columnas) {

              //? impresion de las variables del objeto le quite 4
              this.pdf_registro.text(calf_reprobadas.id, col_mat_text + 1.5 + (j * 24), lineas_alumnos, { align: 'center' });
              this.pdf_registro.text(calf_reprobadas.promedio.toString(), col_mat_text + 10 + (j * 24), lineas_alumnos, { align: 'center' });
              this.pdf_registro.setFontSize(9);
              this.pdf_registro.text(calf_reprobadas.opc, col_mat_text + 18.5 + (j * 24), lineas_alumnos, { align: 'center', maxWidth: 33 });
              maximo_reprobado++
            }
          }

          this.pdf_registro.setFontSize(10);


          // letras.forEach(letra => {
          //   if (alumno.reprobadas.hasOwnProperty(letra)) {
          //     if (maximo_reprobado < 3) {
          //       if (alumno.reprobadas[letra].valor_minimo_aprobatorio != null) {
          //         this.pdf_registro.text(letra, col_mat_text + 7, lineas_alumnos, { align: "center" });
          //         this.pdf_registro.text(alumno.reprobadas[letra].promedio + '', col_mat_text + 15, lineas_alumnos, { align: "center" });
          //         this.pdf_registro.text(alumno.reprobadas[letra].opciones_calificacion.nombre, col_mat_text + 23, lineas_alumnos, { align: "center" });

          //         maximo_reprobado++;

          //         col_mat_text += 24;
          //       }
          //     }
          //   }
          // });

          if (alumno.calificaciones["situacion_escolar"] == 'BR' || alumno.calificaciones["situacion_escolar"] == 'BD' || alumno.calificaciones["situacion_escolar"] == 'BT') {
            this.pdf_registro.setTextColor(this.firma.color_calf_t); //red
            let col_mat_blanco = 330 - total_col_cal;
            let left_op = total_col_cal;
            col_mat = col_mat_blanco;
            if (this.firma.situacion_p_se) {
              this.pdf_registro.setLineWidth(0.8);
              this.pdf_registro.setDrawColor(255, 255, 255);
              // for (let key = 0; key < (opcion_calificacion.length * 3) - 1; key++) {
              for (let key = 0; key < (nuevas_columnas * 3) - 1; key++) {
                col_mat_blanco += 8;
                this.pdf_registro.line(col_mat_blanco, lineas_alumnos - 2.9 + menos_linea, col_mat_blanco, lineas_alumnos + 1.1 + menos_linea);
              }
              this.pdf_registro.setDrawColor(1, 1, 1);
              this.pdf_registro.setLineWidth(0.1);

              this.pdf_registro.text(alumno.calificaciones["situacion_escolar_descripcion"], col_mat + (left_op / 2), lineas_alumnos, { align: "center" });
            }
          }
          this.pdf_registro.setTextColor("black");
          if (this.firma.situacion_p_na) {
            this.pdf_registro.text(alumno.calificaciones["asignaturas_no_acreditadas"] + "", 333, lineas_alumnos, { align: "left" });
          }
          if (this.firma.situacion_p_se) {
            this.pdf_registro.text(alumno.calificaciones["situacion_escolar"], 340, lineas_alumnos, { align: "left" });
          }
          lineas_alumnos += 4.23;
          menos_linea -= 0.022;
        });
        // linea cancelacion diagonal
        this.pdf_registro.setLineWidth(0.3);
        if (data.alumnos.length < 25) {
          this.pdf_registro.line(18, lineas_alumnos - 3, 346, 207.5);
        }

        this.pdf_registro.addPage();
        conteo_lienas = 10;

        //////////////// INFORMACION ALUMNOS /////////////////////
        this.cabecera_alumnos_licenciatura(data, conteo_lienas, p_al, opcion_calificacion, materia_nivel, total_col_cal, 41, 50.5, tam_mat, tamanio_materia, nuevas_columnas);
        this.pdf_registro.setFontSize(10);
        conteo_lienas += 45;

        this.pdf_registro.text("ALUMNOS QUE REPITEN CURSO", 185, conteo_lienas, { align: "center" });

        conteo_lienas += 3;
        let alumnos_repiten = 6;
        this.alumnos_lineas_licenciatura(alumnos_repiten, conteo_lienas, p_al, opcion_calificacion, materia_nivel, total_col_cal, tam_mat, tamanio_materia, nuevas_columnas);
        //////////////// ALUMNOS QUE REPITEN
        lineas_alumnos = conteo_lienas + 3; let conteo_repiten = 0;
        if (this.alumnos_repeticion.hasOwnProperty(data.id)) {
        
          this.pdf_registro.setFont("helvetica", "", "normal");
          menos_linea = 0;
          this.alumnos_repeticion[data.id].forEach((alumno, key) => {
            conteo_repiten++;
            if (alumno.calificaciones["asignaturas_no_acreditadas"] == 0) {
              alumno.calificaciones["asignaturas_no_acreditadas"] = "=="
            }
            this.pdf_registro.setTextColor("black");
            this.pdf_registro.text(conteo_repiten + "", 13.5, lineas_alumnos, { align: "center" });
            if (this.firma.situacion_a_na) {
              this.pdf_registro.text(alumno.calificaciones["asignaturas_no_acreditadas_antes"] + "", 21, lineas_alumnos, { align: "left" });
            }
            if (this.firma.situacion_a_se) {
              this.pdf_registro.text(alumno.calificaciones["situacion_escolar_antes"], 29, lineas_alumnos, { align: "left" });
            }
            this.pdf_registro.text(alumno.matricula.substr(4, alumno.matricula.length), 43, lineas_alumnos, { align: "center" });
            let left_mas = 0;
            if (p_al < 155) {
              left_mas = (p_al / 3) - 21.5;
              if (left_mas < 0) {
                left_mas = 4;
              }
            } else {
              left_mas = (p_al / 3) - 23;
            }
            this.pdf_registro.text(alumno.apellido_paterno, 52, lineas_alumnos, { align: "left" });
            this.pdf_registro.text(alumno.apellido_materno, 52 + left_mas, lineas_alumnos, { align: "left" });
            this.pdf_registro.text(alumno.nombre, 52 + (left_mas * 2), lineas_alumnos, { align: "left" });

            this.pdf_registro.text(alumno.sexo, p_al + 5, lineas_alumnos, { align: "center" });

            let col_mat = p_al + 8;
            // calificaciones
            materia_nivel.forEach((materia, key) => {
              let tamanio = tamanio_materia[key];
              col_mat += tamanio;
              if (alumno.calificaciones.hasOwnProperty(materia.id)) {
                if (alumno.calificaciones[materia.id][0].promedio < alumno.calificaciones[materia.id][0].valor_minimo_aprobatorio)
                  this.pdf_registro.setTextColor(this.firma.color_calf_r); // red
                else
                  this.pdf_registro.setTextColor("black");
                if (this.firma.calificaciones) {
                  this.pdf_registro.text(alumno.calificaciones[materia.id][0].promedio + '', col_mat - tamanio / 2, lineas_alumnos, { align: "center" });
                }
              }
            });

            col_mat = p_al + 8;

            this.pdf_registro.setTextColor("black");
            let maximo_reprobado = 0;
            let col_mat_text = col_mat - 3;
            letras.forEach(letra => {
              if (alumno.reprobadas.hasOwnProperty(letra)) {
                if (maximo_reprobado < 3) {
                  if (alumno.reprobadas[letra].valor_minimo_aprobatorio != null) {
                    this.pdf_registro.text(letra, col_mat_text + 7, lineas_alumnos, { align: "center" });
                    this.pdf_registro.text(alumno.reprobadas[letra].promedio + '', col_mat_text + 15, lineas_alumnos, { align: "center" });
                    this.pdf_registro.text(alumno.reprobadas[letra].opciones_calificacion.nombre, col_mat_text + 23, lineas_alumnos, { align: "center" });

                    maximo_reprobado++;

                    col_mat_text += 24;
                  }
                }
              }
            });

            if (alumno.calificaciones["situacion_escolar"] == 'BR' || alumno.calificaciones["situacion_escolar"] == 'BD') {
              this.pdf_registro.setTextColor(this.firma.color_calf_t); //red
              let col_mat_blanco = 330 - total_col_cal;
              let left_op = total_col_cal;
              col_mat = col_mat_blanco;
              if (this.firma.situacion_p_se) {
                this.pdf_registro.setLineWidth(0.8);
                this.pdf_registro.setDrawColor(255, 255, 255);
                // for (let key = 0; key < (opcion_calificacion.length * 3) - 1; key++) {
                for (let key = 0; key < (nuevas_columnas * 3) - 1; key++) {
                  col_mat_blanco += 8;
                  this.pdf_registro.line(col_mat_blanco, lineas_alumnos - 2.9 + menos_linea, col_mat_blanco, lineas_alumnos + 1.1 + menos_linea);
                }
                this.pdf_registro.setDrawColor(1, 1, 1);
                this.pdf_registro.setLineWidth(0.1);

                this.pdf_registro.text(alumno.calificaciones["situacion_escolar_descripcion"], col_mat + (left_op / 2), lineas_alumnos, { align: "center" });
              }
            }


            if (this.firma.situacion_p_na) {
              this.pdf_registro.text(alumno.calificaciones["asignaturas_no_acreditadas"] + "", 333, lineas_alumnos, { align: "left" });
            }
            if (this.firma.situacion_p_se) {
              this.pdf_registro.text(alumno.calificaciones["situacion_escolar"], 340, lineas_alumnos, { align: "left" });
            }
            lineas_alumnos += 4.23;
            menos_linea -= 0.022;
          });
        }
        /////////////// FIN REPITEN

        //////////////// INFORMACION ALUMNOS /////////////////////
        conteo_lienas += (alumnos_repiten * 4) + 5;

        this.pdf_registro.text("ALUMNOS DADOS DE ALTA", 185, conteo_lienas, { align: "center" });

        conteo_lienas += 3;
        let alumnos_nuevos = 6;

        this.alumnos_lineas_licenciatura(alumnos_nuevos, conteo_lienas, p_al, opcion_calificacion, materia_nivel, total_col_cal, tam_mat, tamanio_materia, nuevas_columnas);
        //////////////// ALUMNOS ALTA
        lineas_alumnos = conteo_lienas + 3.5; let conteo_alta = 0;
        if (this.alumnos_alta.hasOwnProperty(data.id)) {
         
          this.pdf_registro.setFont("helvetica", "", "normal");
          menos_linea = 0;
          this.alumnos_alta[data.id].forEach((alumno, key) => {
            conteo_alta++;
            this.pdf_registro.setTextColor("black");
            this.pdf_registro.text(conteo_alta + "", 13.5, lineas_alumnos, { align: "center" });
            if (this.firma.situacion_a_na) {
              this.pdf_registro.text(alumno.calificaciones["asignaturas_no_acreditadas_antes"] + "", 21, lineas_alumnos, { align: "left" });
            }
            if (this.firma.situacion_a_se) {
              this.pdf_registro.text(alumno.calificaciones["situacion_escolar_antes"], 29, lineas_alumnos, { align: "left" });
            }
            this.pdf_registro.text(alumno.matricula.substr(4, alumno.matricula.length), 43, lineas_alumnos, { align: "center" });
            let left_mas = 0;
            if (p_al < 155) {
              left_mas = (p_al / 3) - 21.5;
              if (left_mas < 0) {
                left_mas = 4;
              }
            } else {
              left_mas = (p_al / 3) - 23;
            }
            this.pdf_registro.text(alumno.apellido_paterno, 52, lineas_alumnos, { align: "left" });
            this.pdf_registro.text(alumno.apellido_materno, 52 + left_mas, lineas_alumnos, { align: "left" });
            this.pdf_registro.text(alumno.nombre, 52 + (left_mas * 2), lineas_alumnos, { align: "left" });

            this.pdf_registro.text(alumno.sexo, p_al + 5, lineas_alumnos, { align: "center" });

            let col_mat = p_al + 8;
            // calificaciones
            materia_nivel.forEach((materia, key) => {
              let tamanio = tamanio_materia[key];
              col_mat += tamanio;
              if (alumno.calificaciones.hasOwnProperty(materia.id)) {
                if (alumno.calificaciones[materia.id][0].promedio < alumno.calificaciones[materia.id][0].valor_minimo_aprobatorio)
                  this.pdf_registro.setTextColor(this.firma.color_calf_r); // red
                else
                  this.pdf_registro.setTextColor("black");
                if (this.firma.calificaciones) {
                  this.pdf_registro.text(alumno.calificaciones[materia.id][0].promedio + '', col_mat - tamanio / 2, lineas_alumnos, { align: "center" });
                }
              }
            });

            col_mat = p_al + 8;

            this.pdf_registro.setTextColor("black");
            let maximo_reprobado = 0;
            let col_mat_text = col_mat - 3;
            letras.forEach(letra => {
              if (alumno.reprobadas.hasOwnProperty(letra)) {
                if (maximo_reprobado < 3) {
                  if (alumno.reprobadas[letra].valor_minimo_aprobatorio != null) {
                    this.pdf_registro.text(letra, col_mat_text + 7, lineas_alumnos, { align: "center" });
                    this.pdf_registro.text(alumno.reprobadas[letra].promedio + '', col_mat_text + 15, lineas_alumnos, { align: "center" });
                    this.pdf_registro.text(alumno.reprobadas[letra].opciones_calificacion.nombre, col_mat_text + 23, lineas_alumnos, { align: "center" });

                    maximo_reprobado++;

                    col_mat_text += 24;
                  }
                }
              }
            });

            if (alumno.calificaciones["situacion_escolar"] == 'BR' || alumno.calificaciones["situacion_escolar"] == 'BD') {
              this.pdf_registro.setTextColor(this.firma.color_calf_t); //red
              let col_mat_blanco = 330 - total_col_cal;
              let left_op = total_col_cal;
              col_mat = col_mat_blanco;
              if (this.firma.situacion_p_se) {
                this.pdf_registro.setLineWidth(0.8);
                this.pdf_registro.setDrawColor(255, 255, 255);
                // for (let key = 0; key < (opcion_calificacion.length * 3) - 1; key++) {
                for (let key = 0; key < (nuevas_columnas * 3) - 1; key++) {
                  col_mat_blanco += 8;
                  this.pdf_registro.line(col_mat_blanco, lineas_alumnos - 2.9 + menos_linea, col_mat_blanco, lineas_alumnos + 1.1 + menos_linea);
                }
                this.pdf_registro.setDrawColor(1, 1, 1);
                this.pdf_registro.setLineWidth(0.1);

                this.pdf_registro.text(alumno.calificaciones["situacion_escolar_descripcion"], col_mat + (left_op / 2), lineas_alumnos, { align: "center" });
              }
            }

            if (this.firma.situacion_p_na) {
              this.pdf_registro.text(alumno.calificaciones["asignaturas_no_acreditadas"] + "", 333, lineas_alumnos, { align: "left" });
            }
            if (this.firma.situacion_p_se) {
              this.pdf_registro.text(alumno.calificaciones["situacion_escolar"], 340, lineas_alumnos, { align: "left" });
            }
            lineas_alumnos += 4.23;
            menos_linea -= 0.022;
          });
        }
        /////////////// FIN REPITEN
        conteo_lienas += (alumnos_nuevos * 4) + 5;
        this.pdf_registro.setFontSize(10);

        if (footer) {
          footer.forEach(element => {
            let columna = 10;
            let fila = 5;
            let col = 0;
            let fil = 0;
            let col_no = 0;
            let ancho = 0;
            let alto = 0;
            element.estructuras_contenidos.forEach(elem => {
              ancho = 216 * (elem.ancho_porcentaje / 100);
              alto = 279 * (elem.alto_porcentaje / 100);
              col_no = 0;
              if (elem.tipo == "FOTO") {
                this.pdf_registro.addImage(elem.logo, "PNG", columna, fila, ancho, alto, "", "FAST");
              } else {
                try {
                  elem.contenido =
                    "<div style='line-height: 20px;'>" +
                    elem.contenido.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>') +
                    "</div>";

                  this.pdf_registro.fromHTML(elem.contenido, columna, conteo_lienas, {
                    width: ancho + columna
                  });

                } catch (e) {
                  console.log(e);
                }
              }
              columna += ancho + 1;
              col++;

              if (element.columnas == col) {
                col = 0;
                conteo_lienas += alto;
                columna = 5;
                col_no = 1;
              }
            });
            if (col_no == 0) conteo_lienas += alto;
          });
        }
        if (!footer || footer.length == 0) {
          this.pdf_registro.setFontSize(10);

          this.pdf_registro.text("INSCRIPCIÓN O REINSCRIPCIÓN", 66, conteo_lienas, { align: "center" });
          this.pdf_registro.text("ACREDITACIÓN Y REGULARIZACIÓN", 180, conteo_lienas, { align: "center" });
          this.pdf_registro.text("LEGALIZACIÓN DEL DOCUMENTO", 288, conteo_lienas, { align: "center" });

          conteo_lienas += 3;
          this.pdf_registro.setFontSize(8);

          let mitad = (206 - conteo_lienas) / 2;
          this.pdf_registro.setFont("helvetica", "", "bold");
          ////////////////////////////
          this.pdf_registro.setLineWidth(0.1);
          this.pdf_registro.setDrawColor(1, 1, 1);
          this.pdf_registro.setFillColor(255, 255, 255);

          this.pdf_registro.rect(10, conteo_lienas, 108, (206 - conteo_lienas), 'FD');
          this.pdf_registro.line(66, conteo_lienas, 66, 206);
          this.pdf_registro.text("DEPARTAMENTO DE SERVICIOS", 92, conteo_lienas + 3, { align: "center" });
          this.pdf_registro.text("ESCOLARES", 92, conteo_lienas + 6, { align: "center" });
          this.pdf_registro.line(66, conteo_lienas + 8, 118, conteo_lienas + 8);

          //
          this.pdf_registro.line(10, conteo_lienas + mitad, 118, conteo_lienas + mitad);
          this.pdf_registro.line(66, conteo_lienas + mitad - 4, 118, conteo_lienas + mitad - 4);
          this.pdf_registro.line(10, conteo_lienas + mitad + 4, 118, conteo_lienas + mitad + 4);

          this.pdf_registro.text("FECHA:", 69, conteo_lienas + mitad - 1.5, { align: "left" });
          this.pdf_registro.text(this.firma.fecha1, 90, conteo_lienas + mitad - 1.5, { align: "left" });
          this.pdf_registro.text("SELLO DEL PLANTEL", 40, conteo_lienas + mitad + 3, { align: "center" });
          this.pdf_registro.text("FECHA Y SELLO DE VALIDACIÓN", 92, conteo_lienas + mitad + 3, { align: "center" });

          this.pdf_registro.line(10, 198, 118, 198);
          if (this.firma.director_sexo1 == 'H') {
            this.pdf_registro.text("NOMBRE Y FIRMA DEL DIRECTOR", 40, 201.5, { align: "center" });
            this.pdf_registro.text("Y/O RECTOR DEL PLANTEL", 40, 204.5, { align: "center" });
          } else {
            this.pdf_registro.text("NOMBRE Y FIRMA DE LA DIRECTORA", 38, 201.5, { align: "center" });
            this.pdf_registro.text("Y/O RECTORA DEL PLANTEL", 38, 204.5, { align: "center" });
          }
          this.pdf_registro.text("NOMBRE Y FIRMA DE QUIEN VALIDA", 92, 203, { align: "center" });

          if (this.firma.cancelar1) {
            this.pdf_registro.line(10, conteo_lienas, 118, 206);
          }

          ////////////////////////////
          this.pdf_registro.setLineWidth(0.1);
          this.pdf_registro.setDrawColor(1, 1, 1);
          this.pdf_registro.setFillColor(255, 255, 255);

          this.pdf_registro.rect(124, conteo_lienas, 108, (206 - conteo_lienas), 'FD');

          this.pdf_registro.line(180, conteo_lienas, 180, 206);
          this.pdf_registro.text("DEPARTAMENTO DE SERVICIOS", 207, conteo_lienas + 3, { align: "center" });
          this.pdf_registro.text("ESCOLARES", 207, conteo_lienas + 6, { align: "center" });
          this.pdf_registro.line(180, conteo_lienas + 8, 232, conteo_lienas + 8);

          //
          this.pdf_registro.line(124, conteo_lienas + mitad, 232, conteo_lienas + mitad);
          this.pdf_registro.line(180, conteo_lienas + mitad - 4, 232, conteo_lienas + mitad - 4);
          this.pdf_registro.line(124, conteo_lienas + mitad + 4, 232, conteo_lienas + mitad + 4);

          this.pdf_registro.text("FECHA:", 183, conteo_lienas + mitad - 1.5, { align: "left" });
          this.pdf_registro.text(this.firma.fecha2, 203, conteo_lienas + mitad - 1.5, { align: "left" });
          this.pdf_registro.text("SELLO DEL PLANTEL", 150, conteo_lienas + mitad + 3, { align: "center" });
          this.pdf_registro.text("FECHA Y SELLO DE VALIDACIÓN", 206, conteo_lienas + mitad + 3, { align: "center" });

          this.pdf_registro.line(124, 198, 232, 198);

          if (this.firma.director_sexo2 == 'H') {
            this.pdf_registro.text("NOMBRE Y FIRMA DEL DIRECTOR", 150, 201.5, { align: "center" });
            this.pdf_registro.text("Y/O RECTOR DEL PLANTEL", 150, 204.5, { align: "center" });
          } else {
            this.pdf_registro.text("NOMBRE Y FIRMA DE LA DIRECTORA", 151, 201.5, { align: "center" });
            this.pdf_registro.text("Y/O RECTORA DEL PLANTEL", 151, 204.5, { align: "center" });
          }

          this.pdf_registro.text("NOMBRE Y FIRMA DE QUIEN VALIDA", 206, 203, { align: "center" });

          if (this.firma.cancelar2) {
            this.pdf_registro.line(124, conteo_lienas, 232, 206);
          }

          ////////////////////////////
          this.pdf_registro.setLineWidth(0.1);
          this.pdf_registro.setDrawColor(1, 1, 1);
          this.pdf_registro.setFillColor(255, 255, 255);
          this.pdf_registro.rect(238, conteo_lienas, 108, (206 - conteo_lienas), 'FD');
          this.pdf_registro.line(294, conteo_lienas + mitad + 4, 294, 206);

          this.pdf_registro.text("DEPARTAMENTO DE SERVICIOS ESCOLARES", 292, conteo_lienas + 4, { align: "center" });
          this.pdf_registro.line(238, conteo_lienas + 8, 346, conteo_lienas + 8);

          this.pdf_registro.text("PERIODO LEGALIZADO", 292, conteo_lienas + 11.5, { align: "center" });
          this.pdf_registro.text(data.periodos_escolares.nombre, 292, conteo_lienas + 14, { align: "center" });
          this.pdf_registro.line(238, conteo_lienas + 16, 346, conteo_lienas + 16);

          this.pdf_registro.line(238, conteo_lienas + mitad - 4, 346, conteo_lienas + mitad - 4);
          this.pdf_registro.line(238, conteo_lienas + mitad + 4, 346, conteo_lienas + mitad + 4);

          this.pdf_registro.text("FECHA:", 240, conteo_lienas + mitad + 1.5, { align: "left" });
          this.pdf_registro.text(this.firma.fecha3, 260, conteo_lienas + mitad + 1.5, { align: "left" });

          this.pdf_registro.line(238, 198, 346, 198);
          if (this.firma.jefe_sexo1 == 'H') {
            this.pdf_registro.text("NOMBRE Y FIRMA DEL JEFE", 266, 201.5, { align: "center" });
          } else {
            this.pdf_registro.text("NOMBRE Y FIRMA DE LA JEFA", 266, 201.5, { align: "center" });
          }
          this.pdf_registro.text("DE OFICINA", 266, 204.5, { align: "center" });

          if (this.firma.jefe_sexo2 == 'H') {
            this.pdf_registro.text("NOMBRE Y FIRMA DEL JEFE", 320, 201.5, { align: "center" });
          } else {
            this.pdf_registro.text("NOMBRE Y FIRMA DE LA JEFA", 320, 201.5, { align: "center" });
          }
          this.pdf_registro.text("DEL DEPTO.", 320, 204.5, { align: "center" });

          if (this.firma.cancelar3) {
            this.pdf_registro.line(238, conteo_lienas, 346, 206);
          }

          //////////////////////////////////////////////////////////////////////////////////
          this.pdf_registro.setFont("helvetica", "", "normal");
          if (this.firma.director1.search(",") > -1) {
            this.pdf_registro.text(this.firma.director1.split(",")[0], 40, 193, { align: "center" });
            this.pdf_registro.text(this.firma.director1.split(",")[1], 40, 196, { align: "center" });
          } else {
            this.pdf_registro.text(this.firma.director1, 40, 196, { align: "center" });
          }
          if (this.firma.valida1.search(",") > -1) {
            this.pdf_registro.text(this.firma.valida1.split(",")[0], 92, 193, { align: "center" });
            this.pdf_registro.text(this.firma.valida1.split(",")[1], 92, 196, { align: "center" });
          } else {
            this.pdf_registro.text(this.firma.valida1, 92, 196, { align: "center" });
          }
          ////////////////
          if (this.firma.director2.search(",") > -1) {
            this.pdf_registro.text(this.firma.director2.split(",")[0], 150, 193, { align: "center" });
            this.pdf_registro.text(this.firma.director2.split(",")[1], 150, 196, { align: "center" });
          } else {
            this.pdf_registro.text(this.firma.director2, 150, 196, { align: "center" });
          }
          if (this.firma.valida2.search(",") > -1) {
            this.pdf_registro.text(this.firma.valida2.split(",")[0], 206, 193, { align: "center" });
            this.pdf_registro.text(this.firma.valida2.split(",")[1], 206, 196, { align: "center" });
          } else {
            this.pdf_registro.text(this.firma.valida2, 206, 196, { align: "center" });
          }
          ////////////////
          if (this.firma.jefe1.search(",") > -1) {
            this.pdf_registro.text(this.firma.jefe1.split(",")[0], 266, 193, { align: "center" });
            this.pdf_registro.text(this.firma.jefe1.split(",")[1], 266, 196, { align: "center" });
          } else {
            this.pdf_registro.text(this.firma.jefe1, 266, 196, { align: "center" });
          }
          if (this.firma.jefe2.search(",") > -1) {
            this.pdf_registro.text(this.firma.jefe2.split(",")[0], 320, 193, { align: "center" });
            this.pdf_registro.text(this.firma.jefe2.split(",")[1], 320, 196, { align: "center" });
          } else {
            this.pdf_registro.text(this.firma.jefe2, 320, 196, { align: "center" });
          }
        }

        if (hojas < this.dato.length) {
          let conteo_lienas = 5;
          this.pdf_registro.addPage();
        }
      });

      this.cargando = false;
      // this.pdf_registro.autoPrint();
      window.open(this.pdf_registro.output('bloburl'), '_blank');
      /*const string = this.pdf_registro.output("datauristring", "registro_escolaridad.pdf");

      const object =
        "<object border='0' style='border:0px' width='100%' height='100%' data='" +
        string +
        "'></object>";

      const x = window.open();
      x.document.open();
      x.document.write(object);
      x.document.close();*/

    }, 10);
  }

  imprimirRegistroBachillerato() {

  }

  imprimirRegistroProfesionalizacion() {

  }
}
